import { useState, React, useRef, useEffect } from 'react';
import {
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  StepButton,
  Switch
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {
  CreateShipment,
  DispatchShipment,
  FailedLogs,
  GetNextDate,
  MarkAsResolvedLog,
  PickupShipment
} from '../../apis/Agency';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import './PickupShipment.css';
import { useSelector } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Paper from '@mui/material/Paper';
import {
  Autocomplete,
  Button,
  createFilterOptions,
  TextField
} from '@mui/material';
import Stepper from '@mui/material/Stepper';
import { DateTime } from 'luxon';
import Step from '@mui/material/Step';
import { useStyles } from './styles';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import GetShipmentRates from '../GetRate/GetRates';
import { useHistory } from 'react-router-dom';
import { CardTitle } from 'reactstrap';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import ReactQuill from 'react-quill';
import { ErrorToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import QuickQuoteTabPanel from '../GetRate/QuickQuoteTabPanel';
import {
  useIsMobile,
  useIsMobileDevice
} from '../../components/IsMobileHook/IsMobileHook';
import { useMediaQuery, useTheme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function BookShipmentReview(props) {
  const isMobile = useIsMobile();
  const mobileDevice = useIsMobileDevice();
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.down('sm'));
  const specialCharacters = [
    '/',
    '\\',
    '|',
    '`',
    '~',
    '&',
    '^',
    '#',
    '"',
    '!',
    '$',
    '*',
    '{',
    '}',
    '[',
    ']'
  ];
  const handleKeyPress = event => {
    if (event.key === 'Shift' || event.key === 'shift') {
      return;
    }
    if (
      (event.target.tagName === 'INPUT' ||
        event.target.tagName === 'TEXTAREA') &&
      specialCharacters.includes(event.key)
    ) {
      event.preventDefault();
    }
  };

  const handlePaste = async event => {
    if (
      event.target.tagName === 'INPUT' ||
      event.target.tagName === 'TEXTAREA'
    ) {
      event.preventDefault();
      const input = event.target;

      const clipboardData = event.clipboardData.getData('text');
      const specialCharsRegex = new RegExp(
        '[' + specialCharacters.join('\\') + ']',
        'g'
      );
      const sanitizedData = clipboardData.replace(specialCharsRegex, '');

      const cursorPos = input.selectionStart;
      const value = input.value;
      const nWL =
        value.slice(0, cursorPos) +
        sanitizedData +
        value.slice(input.selectionEnd);

      const prototype =
        event.target.tagName === 'TEXTAREA'
          ? window.HTMLTextAreaElement.prototype
          : window.HTMLInputElement.prototype;

      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        prototype,
        'value'
      ).set;
      nativeInputValueSetter.call(event.target, nWL);
      input.setSelectionRange(
        cursorPos + sanitizedData.length,
        cursorPos + sanitizedData.length
      );

      const eventInput = new Event('input', { bubbles: true });
      event.target.dispatchEvent(eventInput);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('paste', handlePaste);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('paste', handlePaste);
    };
  }, []);

  let UpdatedStoredServices = useRef(null);
  const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = '';

    if (userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('Chrome') > -1) {
      browser = 'Chrome';
    } else {
      browser = 'Unknown';
    }

    return browser;
  };

  const browser = detectBrowser();
  const history = useHistory();

  function toLowercaseKeys(obj) {
    if (Array.isArray(obj)) {
      return obj.map(toLowercaseKeys);
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1), // Convert only the first letter of the key to lowercase
          toLowercaseKeys(value)
        ])
      );
    }
    return obj;
  }

  const mapPropsToDesiredFormat = (pickUpReqData, createReqData) => {
    return {
      shipmentType: pickUpReqData?.ShipmentType || '',
      locationFull: `${createReqData?.location?.state?.data?.locationName}`,
      location: `${createReqData?.location?.state?.data?.locationName}`,
      paymentType: pickUpReqData?.PaymentType || '0',
      shipFrom: {
        city: pickUpReqData?.Shipper?.Address?.City || '',
        stateOrProvinceCode:
          pickUpReqData?.Shipper?.Address?.StateOrProvinceCode || '',
        postalCode: pickUpReqData?.Shipper?.Address?.PostalCode || '',
        countryCode: pickUpReqData?.Shipper?.Address?.CountryCode || '',
        residential: pickUpReqData?.Shipper?.Address?.Residential || false,
        streetLines: pickUpReqData?.Shipper?.Address?.StreetLines || ''
      },
      shipTo: {
        city: pickUpReqData?.Recipient?.Address?.City || '',
        stateOrProvinceCode:
          pickUpReqData?.Recipient?.Address?.StateOrProvinceCode || '',
        postalCode: pickUpReqData?.Recipient?.Address?.PostalCode || '',
        countryCode: pickUpReqData?.Recipient?.Address?.CountryCode || '',
        residential: pickUpReqData?.Recipient?.Address?.Residential || false,
        streetLines: pickUpReqData?.Recipient?.Address?.StreetLines || ''
      },

      shipmentDate: new Date().toISOString(), // Current timestamp
      isHazmat: pickUpReqData?.IsHazmat || false,
      commodityInfo: pickUpReqData?.LineItems?.map(item => ({
        freightClass: item?.FreightClass || '',
        packaging: item?.Packaging || '',
        units: item?.Units ? String(item?.Units) : '0',
        pieces: item?.Pieces ? String(item?.Pieces) : '0',
        weight: {
          units: item?.Weight?.Units || '',
          value: item?.Weight?.Value ? String(item?.Weight.Value) : '0'
        },
        nmfc: item?.NMFC || '',
        dimensions: {
          length: item?.Dimensions?.length || 0,
          width: item?.Dimensions?.width || 0,
          height: item?.Dimensions?.height || 0,
          dimensionsUom: item.Dimensions?.dimensionsUom || ''
        },
        isStackable: pickUpReqData?.IsStackable || false
      })),
      pickupOptions: {
        inside: pickUpReqData?.PickupOptions?.Inside || false,
        liftGateServices:
          pickUpReqData?.PickupOptions?.LiftGateServices || false,
        residential: pickUpReqData?.PickupOptions?.Residential || false,
        secureAccess: pickUpReqData?.PickupOptions?.SecureAccess || false,
        limitedAccess: pickUpReqData?.PickupOptions?.LimitedAccess || false,
        freezeProtection:
          pickUpReqData?.PickupOptions?.FreezeProtection || false,
        overLength: pickUpReqData?.PickupOptions?.OverLength || false,
        overLengthValue: pickUpReqData?.PickupOptions?.OverLengthValue || 0,
        callBeforeDelivery:
          pickUpReqData?.PickupOptions?.CallBeforeDelivery || false
      },
      deliveryOptions: {
        inside: pickUpReqData?.DeliveryOptions?.Inside || false,
        liftGateServices:
          pickUpReqData?.DeliveryOptions?.LiftGateServices || false,
        residential: pickUpReqData?.DeliveryOptions?.Residential || false,
        secureAccess: pickUpReqData?.DeliveryOptions?.SecureAccess || false,
        limitedAccess: pickUpReqData?.DeliveryOptions?.LimitedAccess || false,
        freezeProtection:
          pickUpReqData?.DeliveryOptions?.FreezeProtection || false,
        overLength: pickUpReqData?.DeliveryOptions?.OverLength || false,
        overLengthValue: pickUpReqData?.DeliveryOptions?.OverLengthValue || 0,
        callBeforeDelivery:
          pickUpReqData?.DeliveryOptions?.CallBeforeDelivery || false
      },
      codAmount: 0, // Static as per sample
      declaredValue: 0, // Static as per sample
      agencyId: pickUpReqData?.AgencyId || 0,
      isGuaranteed: false, // Assuming static
      locationId: pickUpReqData?.LocationId || 0
    };
  };
  const ApiObjData = JSON.parse(props?.location?.state?.pickupRowData);
  const mappedData = mapPropsToDesiredFormat(
    ApiObjData,
    props?.location?.state?.data
  );
  const failedShip = props?.location?.state?.origin === 'Logs';
  const quickQuoteFlow = props?.location?.state?.rateType === 'Quick Quote';
  const PreviousProps = failedShip
    ? mappedData
    : props?.location?.state?.pickupRowData !== undefined && ApiObjData;
  const selectedLocDetails = props?.location?.state?.userLocationsArr?.filter(
    items => items.id === props?.location?.state?.locationId
  );

  const FailedLogsData = props?.location?.state?.data;
  const shipmentMiles = failedShip
    ? FailedLogsData?.shipmentMiles
    : props?.location?.state?.shipmentMiles;
  const dateNow = new Date();
  const year = dateNow.getFullYear();
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month =
    monthWithOffset.toString().length < 2
      ? `0${monthWithOffset}`
      : monthWithOffset;
  const date =
    dateNow.getUTCDate().toString().length < 2
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();

  const materialDateInput = `${year}-${month}-${date}`;

  const classes = useStyles();
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const CarrierRateData = useSelector(state => state.getCarrierRates);

  const [pickupNumber, setPickupNumber] = useState(
    PreviousProps?.pickupNumber ? PreviousProps?.pickupNumber : ''
  );
  const assignedProNmb = ApiObjData.proNumber;
  const assignedBolNmb = ApiObjData.bolNumber;
  const [proNumber, setProNumber] = useState(assignedProNmb);
  const [refOrQuoteNmb, setRefOrQuoteNmb] = useState(
    PreviousProps?.quoteNumber ? PreviousProps?.quoteNumber : ''
  );

  const [open, setOpen] = useState(false);
  const [openOtherCarrier, setOpenOtherCarrier] = useState(false);
  const [otherCarrierName, setOtherCarrierName] = useState('');
  const [truckNumber, setTruckNumber] = useState('');
  const [driverName, setDriverName] = useState('');
  const [driverNumber, setDriverNumber] = useState('');
  const [isThirdPartyRate, setIsThirdPartyRate] = useState(false);
  const [lowestCostCarrierID, setLowestCostCarrierID] = useState(null);
  const [lowestCostCarrier, setLowestCostCarrier] = useState(null);
  const [quickestCarrierID, setQuickestCarrierID] = useState(null);
  const [quickestCarrier, setQuickestCarrier] = useState(null);
  const [leastCostAgencySurcharge, setLeastCostAgencySurcharge] =
    useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [skipNextChange, setSkipNextChange] = useState(false);
  const [destinationPhoneNumber, setDestinationPhoneNumber] = useState();
  const [carrierName, setCarrierName] = useState(null);
  const [originEmail, setOriginEmail] = useState();
  const [destinationEmail, setDestinationEmail] = useState('');
  const [selectedCarrierID, setSelectedCarrierID] = useState(null);
  const [carrierIdForApi, setCarrierIdForApi] = useState(0);

  const [originDate, setOriginDate] = useState(materialDateInput);
  const [destinationDate, setDestinationDate] = useState(new Date());
  const [originOpenTimeValue, setOriginOpenTimeValue] = useState('08:00');
  const [originCloseTimeValue, setOriginCloseTimeValue] = useState('16:00');
  const [destinationOpenTimeValue, setDestinationOpenTimeValue] =
    useState('09:00');
  const [destinationCloseTimeValue, setDestinationCloseTimeValue] =
    useState('17:00');
  const [shipmentBooked, setShipmentBooked] = useState(false);
  const [pickUpLoader, setPickUpLoader] = useState(false);
  const [shipmentDispatchMsg, setShipmentDispatchMsg] = useState('');
  const [shipmentDispatchFailed, setShipmentDispatchFailed] = useState(false);
  const [pickupReferenceNumber, setPickupReferenceNumber] = useState('');
  const [pickupSuccessRemarks, setPickupSuccessRemarks] = useState('');
  const [shipmentFailed, setShipmentFailed] = useState(false);
  const [shipmentFailedMsg, setShipmentFailedMsg] = useState('');
  const [itemDescription, setItemDescription] = useState(
    PreviousProps?.itemDescription ? PreviousProps?.itemDescription : ''
  );
  const ClassArray = [
    '50',
    '55',
    '60',
    '65',
    '70',
    '77.5',
    '85',
    '92.5',
    '100',
    '110',
    '125',
    '150',
    '175',
    '200',
    '250',
    '300',
    '400',
    '500'
  ];
  const [value, setValue] = useState(0);
  const [finalCommodityInfoApi, setFinalCommodityInfoApi] = useState([]);
  const [totalWeighSum, setTotalWeightSum] = useState('');
  const [newAddedClassRow, setNewAddedClassRow] = useState([
    PreviousProps?.carrierApiNames === 'carrierApiNames'
      ? {
          WeightLBS: CarrierRateData?.commodityInfo?.[0]?.weight?.value,
          Class: CarrierRateData?.commodityInfo?.[0]?.freightClass,
          NMFCnumber: CarrierRateData?.commodityInfo?.[0]?.nmfc
        }
      : {
          WeightLBS: PreviousProps?.pickupRowData?.details?.[0]?.grossWeight,
          Class: CarrierRateData?.commodityInfo?.[0]?.freightClass,
          NMFCnumber: CarrierRateData?.commodityInfo?.[0]?.nmfc
        }
  ]);
  function formatDate(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ).toLocaleDateString('en-CA');
  }
  const [totalLBSWeightDimensions, setTotalLBSWeightDimensions] = useState('');
  const [totalLBSWeightClass, setTotalLBSWeightClass] = useState('');
  const handlePushAddedCommodityInfo = TotalWeightSum => {
    let CommodityInfoApi = [
      {
        freightClass: newAddedClassRow[0].Class,
        packaging: 'Pallet',
        pieces: 1,
        weight: {
          units: 'lbs',
          value: TotalWeightSum ? TotalWeightSum : 0
        },
        nmfc: newAddedClassRow[0].NMFCnumber,
        isStackable: false,

        dimensions: {
          length: 0,
          width: 0,
          height: 0,
          dimensionsUom: 'cm'
        }
      }
    ];

    setFinalCommodityInfoApi(CommodityInfoApi);
  };
  const [BOLNumber, setBOLNumber] = useState(assignedBolNmb);
  const [PoRefNumber, setPoRefNumber] = useState('');
  const [deliveryRemarks, setDeliveryRemarks] = useState('');
  const [deliveryRemarksHtml, setDeliveryRemarksHtml] = useState('');
  const [pickupRemarks, setPickupRemarks] = useState('');
  const [pickupRemarksHtml, setPickupRemarksHtml] = useState('');
  const [overLengthValue, setOverLengthValue] = useState('');
  const [isOverLength, setIsOverLength] = useState(false);
  const [stackableSwitch, setStackableSwitch] = useState(false);
  const [CODAmount, setCODAmount] = useState('');
  const [DeclaredValue, setDeclaredValue] = useState('');
  const [pickUpChecked, setPickUpChecked] = useState(true);
  const [deliveryChecked, setDeliveryChecked] = useState(true);
  const [hazmatSwitch, setHazmatSwitch] = useState(false);
  const [insidePickupSwitch, setInsidePickupSwitch] = useState(false);
  const [liftgatePickupSwitch, setLiftgatePickupSwitch] = useState(false);
  const [residentialPickupSwitch, setResidentialPickupSwitch] = useState(false);
  const [secureAccesPickupSwitch, setSecureAccesPickupSwitch] = useState(false);
  const [limitedPickupAccessSwitch, setLimitedPickupAccessSwitch] =
    useState(false);
  const [freezeProtectionPickupSwitch, setFreezeProtectionPickupSwitch] =
    useState(false);
  const [overlengthPickupSwitch, setOverlengthPickupSwitch] = useState(false);
  //delivery switch states
  const [insideDeliverySwitch, setInsideDeliverySwitch] = useState(false);
  const [liftgateDeliverySwitch, setLiftgateDeliverySwitch] = useState(false);
  const [residentialDeliverySwitch, setResidentialDeliverySwitch] =
    useState(false);
  const [limitedDeliverySwitch, setLimitedDeliverySwitch] = useState(false);
  const [secureAccesDeliverySwitch, setSecureAccesDeliverySwitch] =
    useState(false);
  const [
    callBeforeDeliveryServicesSwitch,
    setCallBeforeDeliveryServicesSwitch
  ] = useState(false);

  const [reloadQuote, setReloadQuote] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedCarrierIDQuoteRates, setSelectedCarrierIDQuoteRates] =
    useState('');
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState('');
  const [selectedCarrierQuotaionID, setSelectedCarrierQuotaionID] =
    useState('');
  const [totalNetChargeState, setTotalNetChargeState] = useState('');
  const [serviceTypeApi, setServiceTypeApi] = useState('');
  const [transitDays, setTransitDays] = useState('');
  const [selectedCarrierNameQuoteRates, setSelectedCarrierNameQuoteRates] =
    useState('');
  const [allRatesFetched, setAllRatesFetched] = useState(false);
  const [originName, setOriginName] = useState('');
  const [originAddress, setOriginAddress] = useState('');
  const [originCompanyName, setOriginCompanyName] = useState('');
  const [destinationName, setDestinationName] = useState('');
  const [destinationCompanyName, setDestinationCompanyName] = useState('');
  const [destinationAddress, setDestinationAddress] = useState('');
  const [saleOrderNumber, setSaleOrderNumber] = useState('');
  const [customerPoNmb, setCustomerPoNmb] = useState('');
  const [shipmentId, setShipmentId] = useState('');
  const [apiCalDate, setApiCalDate] = useState('');
  const [apiDisplayDate, setApiDisplayDate] = useState('');
  const [originTerminalInfo, setOriginTerminalInfo] = useState({
    contact: {
      personName: '',
      phoneNumber: '',
      faxNumber: '',
      companyName: '',
      phoneExtension: '',
      email: ''
    },
    address: {
      city: '',
      stateOrProvinceCode: '',
      postalCode: '',
      countryCode: '',
      residential: true,
      streetLines: ''
    }
  });

  const [destinationTerminalInfo, setDestinationTerminalInfo] = useState({
    contact: {
      personName: '',
      phoneNumber: '',
      faxNumber: '',
      companyName: '',
      phoneExtension: '',
      email: ''
    },
    address: {
      city: '',
      stateOrProvinceCode: '',
      postalCode: '',
      countryCode: '',
      residential: true,
      streetLines: ''
    }
  });
  const [carrierShipType, setCarrierShipType] = useState('');
  const [surchargesArr, setSurchargesArr] = useState({
    surchageType: '',
    level: '',
    description: '',
    amount: {
      currency: '',
      amount: 0
    },
    percentage: 0,
    order: 0
  });
  const enterOriginName = useRef(null);
  const enterOriginCompany = useRef(null);
  const enterOriginStreet = useRef(null);
  const enterOriginEmail = useRef(null);
  const enterOriginPhone = useRef(null);
  const enterDestinationName = useState(null);
  const enterDestinationSteet = useState(null);
  const enterDestinationCompany = useRef(null);
  const enterDestinationEmail = useRef(null);
  const enterSONumbe = useRef(null);
  const enterDestinationPhone = useRef(null);
  function cleanHtmlString(html) {
    // Create a temporary div to decode HTML entities like &nbsp;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const decoded = tempDiv.textContent || tempDiv.innerText || '';

    // Remove all HTML tags using regex
    const cleaned = decoded.replace(/<\/?[^>]+(>|$)/g, '').trim();

    return cleaned;
  }
  useEffect(() => {
    if (failedShip) {
      const lowercaseData = toLowercaseKeys(ApiObjData);
      setSelectedCarrierNameQuoteRates(ApiObjData?.Carrier.Name);
      setSelectedCarrierIDQuoteRates(ApiObjData?.Carrier.Id);
      setSelectedDeliveryDate(ApiObjData?.deliveryTime);
      // setSelectedIndex(index);
      setSelectedCarrierQuotaionID(ApiObjData?.QuotationId);
      setTotalNetChargeState(ApiObjData?.QuotationCharges);
      setServiceTypeApi(ApiObjData?.ServiceType);
      setTransitDays(ApiObjData?.EstimatedTransitDays);
      setOriginTerminalInfo(lowercaseData?.originTerminal);
      setDestinationTerminalInfo(lowercaseData?.destinationTerminal);
      setCarrierShipType(ApiObjData?.ShipmentType);
      // setIsThirdPartyRate(ApiObjData?.PaymentType);
      setLowestCostCarrierID(FailedLogsData?.leastCostCarrier);
      setLowestCostCarrier(FailedLogsData?.leastCost);
      setLeastCostAgencySurcharge(FailedLogsData?.leastCostAgencySurcharge);
      setQuickestCarrierID(FailedLogsData?.leastTransitCarrier);
      setQuickestCarrier(FailedLogsData?.leastTransitDays);
      setSaleOrderNumber(FailedLogsData?.soNumber);
      setSurchargesArr(ApiObjData?.Surcharges);
      setItemDescription(ApiObjData?.LineItems[0]?.Description);
      setCustomerPoNmb(props?.location?.state?.data?.clientPONumber);
      setOriginDate(ApiObjData?.PickupDate);
      setHazmatSwitch(ApiObjData?.IsHazmat);

      const formattedValue = ApiObjData?.Shipper?.Contact?.PhoneNumber.replace(
        /^(\d{3})(\d{3})(\d{4})$/,
        '($1) $2-$3'
      );
      setPhoneNumber(prev => prev || formattedValue || '');
      setOriginName(
        prev => prev || ApiObjData?.Shipper?.Contact?.PersonName || ''
      );
      setOriginAddress(
        prev => prev || ApiObjData?.Shipper?.Address?.StreetLines || ''
      );
      setOriginCompanyName(
        prev => prev || ApiObjData?.Shipper?.Contact?.CompanyName || ''
      );
      setOriginEmail(prev => prev || ApiObjData?.Shipper?.Contact?.Email || '');
      const formattedDestinationValue =
        ApiObjData?.Recipient?.Contact?.PhoneNumber.replace(
          /^(\d{3})(\d{3})(\d{4})$/,
          '($1) $2-$3'
        );
      setDestinationPhoneNumber(
        prev => prev || formattedDestinationValue || ''
      );
      setDestinationName(
        prev => prev || ApiObjData?.Recipient?.Contact?.PersonName || ''
      );
      setDestinationAddress(
        prev => prev || ApiObjData?.Recipient?.Address?.StreetLines || ''
      );
      setDestinationCompanyName(
        prev => prev || ApiObjData?.Recipient?.Contact?.CompanyName || ''
      );
      setDestinationEmail(
        prev => prev || ApiObjData?.Recipient?.Contact?.Email || ''
      );
    }
    if (!isThirdPartyRate) {
      if (PreviousProps?.paymentType == 0) {
        setDestinationPhoneNumber(prev => prev || '');
        setDestinationAddress(prev => prev || '');
        setDestinationName(prev => prev || '');
        setDestinationCompanyName(prev => prev || '');
        setDestinationEmail(prev => prev || '');
        setPhoneNumber(
          prev => prev || selectedLocDetails[0]?.contactPhone || ''
        );
        setOriginName(prev => prev || selectedLocDetails[0]?.contactName || '');
        setOriginAddress(
          prev => prev || selectedLocDetails[0]?.streetLines || ''
        );
        setOriginCompanyName(
          prev => prev || selectedLocDetails[0]?.companyName || ''
        );
        setOriginEmail(
          prev =>
            prev || selectedLocDetails[0]?.contactEmail.split(',')[0] || ''
        );
      }
      if (PreviousProps?.paymentType == 1) {
        setPhoneNumber(prev => prev || '');
        setOriginAddress(prev => prev || '');
        setOriginName(prev => prev || '');
        setOriginCompanyName(prev => prev || '');
        setOriginEmail(prev => prev || '');
        setDestinationPhoneNumber(
          prev => prev || selectedLocDetails[0]?.contactPhone || ''
        );
        setDestinationName(
          prev => prev || selectedLocDetails[0]?.contactName || ''
        );
        setDestinationAddress(
          prev => prev || selectedLocDetails[0]?.streetLines || ''
        );
        setDestinationCompanyName(
          prev => prev || selectedLocDetails[0]?.companyName || ''
        );
        setDestinationEmail(
          prev =>
            prev || selectedLocDetails[0]?.contactEmail.split(',')[0] || ''
        );
      }
    } else if (props?.location?.state?.origin !== 'Logs') {
      // For third-party rate, allow edits without resetting state
      setDestinationPhoneNumber(prev => prev || '');
      setDestinationAddress(prev => prev || '');
      setDestinationCompanyName(prev => prev || '');
      setDestinationEmail(prev => prev || '');
      setDestinationName(prev => prev || '');

      setPhoneNumber(prev => prev || '');
      setOriginAddress(prev => prev || '');
      setOriginName(prev => prev || '');

      setOriginCompanyName(prev => prev || '');
      setOriginEmail(prev => prev || '');
    }

    // Cleanup function to reset states when component unmounts
    return () => {
      if (!isThirdPartyRate) {
        // Reset only in non-third-party scenarios
        setDestinationPhoneNumber('');
        setDestinationAddress('');
        setDestinationCompanyName('');
        setDestinationEmail('');
        setPhoneNumber('');
        setOriginAddress('');
        setOriginCompanyName('');
        setOriginEmail('');
        setOriginName('');
        setDestinationName('');
      }
    };
  }, [isThirdPartyRate]);

  useEffect(() => {
    return () => {
      setSelectedCarrierNameQuoteRates('');
      setSelectedCarrierIDQuoteRates('');
      setSelectedDeliveryDate('');
      setSelectedIndex('');
      setSelectedCarrierQuotaionID('');
      setTotalNetChargeState('');
      setServiceTypeApi('');
      setTransitDays('');
      setOriginTerminalInfo('');
      setDestinationTerminalInfo('');
      setCarrierShipType('');
      setIsThirdPartyRate('');
    };
  }, []);

  useEffect(() => {
    if (failedShip) {
      handleNext(1);
    }
  }, []);

  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [manageShipPermissions, setManageShipPermissions] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const currentScreen = useLocation();

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Quick Quote'
    );
    const filteredManagePermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Manage-Shipments'
    );
    setManageShipPermissions(filteredManagePermissions);
    setUserPermissionsArr(filteredCarrierPermissions);
  }, [userRolePermissions]);

  const checkAllCarriersRates = (callCount, apisLenght) => {
    if (callCount === apisLenght) {
      setAllRatesFetched(true);
    } else {
      setAllRatesFetched(false);
    }
  };

  const handleListItemClick = (items, index) => {
    // event.preventDefault();
    const numericValue = parseInt(items.transitTime, 10); // Convert '05' to 5
    setSelectedCarrierNameQuoteRates(items.carrierName);
    setSelectedCarrierIDQuoteRates(items.carrierID);
    setSelectedDeliveryDate(items.deliveryTime);
    setSelectedIndex(index);
    setSelectedCarrierQuotaionID(items.quotationNumber);
    setTotalNetChargeState(items.totalNetCharge);
    setServiceTypeApi(items.serviceType);
    setTransitDays(isNaN(numericValue) ? '' : numericValue);
    setOriginTerminalInfo(items.originTerminal);
    setDestinationTerminalInfo(items.destinationTerminal);
    setCarrierShipType(items.carrierType);
    setIsThirdPartyRate(items.isThirdPartyRate);
    setLowestCostCarrierID(items.leastCostCarrier);
    setLowestCostCarrier(items.leastCost);
    setQuickestCarrierID(items.leastTransitCarrier);
    setQuickestCarrier(items.leastTransitDays);
    setLeastCostAgencySurcharge(items.leastCostAgencySurcharge);
    // setSurchargesArr(items.surcharges);

    // Recursive function to replace null values with empty strings in any nested structure
    const replaceNulls = obj => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (value === null) {
            return [key, ''];
          } else if (typeof value === 'object' && value !== null) {
            // If the value is an object, recursively apply replaceNulls
            return [key, replaceNulls(value)];
          }
          return [key, value];
        })
      );
    };

    // Apply the function to each item in the surcharges array
    const cleanSurcharges = items.surcharges.map(surcharge =>
      replaceNulls(surcharge)
    );

    setSurchargesArr(cleanSurcharges);

    return false;
  };

  useEffect(() => {
    if (transitDays) {
      calculateFutureDate(transitDays);
    }
  }, [originDate, transitDays]);

  const calculateFutureDate = days => {
    // const today = new Date(originDate); // Get the current date
    // const futureDate = new Date(today); // Create a copy of the current date
    // const apiDate = futureDate.toLocaleDateString('en-US', {
    //   // weekday: 'long', // Day of the week
    //   year: 'numeric', // Full year
    //   month: 'numeric', // Full month name
    //   day: 'numeric' // Day of the month
    // });
    // axios
    //   .get(
    //     `https://a.maxease.net/business-days/?pickup_date=${originDate}&transit_days=${days}`
    //   )
    GetNextDate(originDate, days, 'MMM dd, yyyy')
      .then(res => {
        setApiCalDate(res.data.standardFormat);

        setApiDisplayDate(res.data.customFormat);
      })
      .catch(err => console.log(err, 'days api err_________>>>.'));
    // futureDate.setDate(today.getDate() + days); // Add the number of days

    // Format the date (optional, for readability)
  };

  const [onclickSelectedRow, setOnclickSelectedRow] = useState();

  !onclickSelectedRow === null &&
    setTimeout(() => {
      setOnclickSelectedRow(null);
    }, 5000);

  const handlePickupServices = v => {
    setPickUpChecked(c => !c);
    // checkPickupStatus();
    // setDeliveryChecked(false);
  };

  const handleDeliveryServices = () => {
    setDeliveryChecked(c => !c);
    // checkDeliveryStatus();
    // setPickUpChecked(false);
  };

  const handleDeliveryServicesChange = switchName => {
    if (switchName === 'Inside Delivery') {
      setInsideDeliverySwitch(c => !c);
    } else if (switchName === 'Lift Gate Delivery') {
      setLiftgateDeliverySwitch(c => !c);
    } else if (switchName === 'Residential Delivery') {
      setResidentialDeliverySwitch(c => !c);
    } else if (switchName === 'Secure Access') {
      setSecureAccesDeliverySwitch(c => !c);
    } else if (switchName === 'Call Before Delivery') {
      setCallBeforeDeliveryServicesSwitch(c => !c);
    } else setLimitedDeliverySwitch(c => !c);
    DisableReloadButton();
  };

  const handlePickUpServicesChange = switchName => {
    if (switchName === 'hazmat') {
      setHazmatSwitch(c => !c);
    } else if (switchName === 'Stackable') {
      setStackableSwitch(c => !c);
    } else if (switchName === 'Inside Pickup') {
      setInsidePickupSwitch(c => !c);
    } else if (switchName === 'Lift Gate Services') {
      setLiftgatePickupSwitch(c => !c);
    } else if (switchName === 'Residential Pickup') {
      setResidentialPickupSwitch(c => !c);
    } else if (switchName === 'Secure Access') {
      setSecureAccesPickupSwitch(c => !c);
    } else if (switchName === 'Freeze Protection') {
      setFreezeProtectionPickupSwitch(c => !c);
    } else if (switchName === 'Overlength') {
      setOverlengthPickupSwitch(c => !c);
      setIsOverLength(!isOverLength);
    } else setLimitedPickupAccessSwitch(c => !c);
  };
  const rando = max => Math.floor(Math.random() * max);
  const words = ['Paper', 'Rock', 'Scissors'];
  const rawData = [];

  for (let i = 0; i < 100; i++)
    rawData.push({ id: rando(300), name: words[i % words.length] });

  const handleResetAllData = () => {
    handleReset();
    setCarrierName(null);
    setPickupNumber('');
    setProNumber('');
    setOriginOpenTimeValue('');
    setOriginCloseTimeValue('');
    setDestinationDate(new Date());
    setDestinationOpenTimeValue('');
    setDestinationCloseTimeValue('');
    setPaymentType('');
    setBOLNumber('');
    setHazmatSwitch(!hazmatSwitch);
    setDeliveryRemarks('');
    setPickupRemarks('');
    setInsidePickupSwitch(false);
    setLiftgatePickupSwitch(false);
    setResidentialPickupSwitch(false);
    setSecureAccesPickupSwitch(false);
    setLimitedPickupAccessSwitch(false);
    setFreezeProtectionPickupSwitch(false);
    setOverlengthPickupSwitch(false);
    setOverLengthValue('');
    setInsideDeliverySwitch(false);
    setLiftgateDeliverySwitch(false);
    setResidentialDeliverySwitch(false);
    setSecureAccesDeliverySwitch(false);
    setLimitedDeliverySwitch(false);
    setCallBeforeDeliveryServicesSwitch(false);
    setCODAmount('');
    setDeclaredValue('');
  };

  const handleOtherCarrierClose = () => {
    setOpenOtherCarrier(false);
    setOpen(true);
    setCarrierName(null);
    // setOtherCarrierName('');
  };
  const handleSaveOtherCarrier = () => {
    const errors = {};
    if (!otherCarrierName) {
      errors['otherCarrierName'] = 'Enter carrier name';
    } else if (!truckNumber) {
      errors['truckNumber'] = 'Enter truck number';
    } else if (!driverName) {
      errors['driverName'] = 'Enter driver name';
    } else if (!driverNumber) {
      errors['driverNumber'] = 'Enter driver number';
    } else if (phoneNumberValidError) {
      errors['driverNumber'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
    }
    setValidationErrors(errors);
    if (otherCarrierName && truckNumber && driverName && driverNumber) {
      handleOtherCarrierClose();
    }
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  // Update the runtime state directly
  const updateRuntimeState = () => {
    UpdatedStoredServices.current = {
      insideDeliverySwitch: insideDeliverySwitch,
      liftgateDeliverySwitch: liftgateDeliverySwitch,
      residentialDeliverySwitch: residentialDeliverySwitch,
      secureAccesDeliverySwitch: secureAccesDeliverySwitch,
      limitedDeliverySwitch: limitedDeliverySwitch,
      callBeforeDeliveryServicesSwitch: callBeforeDeliveryServicesSwitch,
      insidePickupSwitch: insidePickupSwitch,
      liftgatePickupSwitch: liftgatePickupSwitch,
      residentialPickupSwitch: residentialPickupSwitch,
      secureAccesPickupSwitch: secureAccesPickupSwitch,
      limitedPickupAccessSwitch: limitedPickupAccessSwitch,
      freezeProtectionPickupSwitch: freezeProtectionPickupSwitch,
      overlengthPickupSwitch: overlengthPickupSwitch,
      hazmatSwitch: hazmatSwitch,
      CODAmount: CODAmount,
      DeclaredValue: DeclaredValue,
      OverLengthValue: overLengthValue
    };
    // No re-render will be triggered
  };

  const DisableReloadButton = () => {
    if (!allRatesFetched) {
      return true;
    }
    if (UpdatedStoredServices?.current === null) {
      return true;
    } else if (
      insideDeliverySwitch ===
        UpdatedStoredServices?.current?.insideDeliverySwitch &&
      liftgateDeliverySwitch ===
        UpdatedStoredServices?.current?.liftgateDeliverySwitch &&
      residentialDeliverySwitch ===
        UpdatedStoredServices?.current?.residentialDeliverySwitch &&
      secureAccesDeliverySwitch ===
        UpdatedStoredServices?.current?.secureAccesDeliverySwitch &&
      limitedDeliverySwitch ===
        UpdatedStoredServices?.current?.limitedDeliverySwitch &&
      callBeforeDeliveryServicesSwitch ===
        UpdatedStoredServices?.current?.callBeforeDeliveryServicesSwitch &&
      insidePickupSwitch ===
        UpdatedStoredServices?.current?.insidePickupSwitch &&
      liftgatePickupSwitch ===
        UpdatedStoredServices?.current?.liftgatePickupSwitch &&
      residentialPickupSwitch ===
        UpdatedStoredServices?.current?.residentialPickupSwitch &&
      secureAccesPickupSwitch ===
        UpdatedStoredServices?.current?.secureAccesPickupSwitch &&
      limitedPickupAccessSwitch ===
        UpdatedStoredServices?.current?.limitedPickupAccessSwitch &&
      freezeProtectionPickupSwitch ===
        UpdatedStoredServices?.current?.freezeProtectionPickupSwitch &&
      hazmatSwitch === UpdatedStoredServices?.current?.hazmatSwitch &&
      CODAmount === UpdatedStoredServices?.current?.CODAmount &&
      DeclaredValue === UpdatedStoredServices?.current?.DeclaredValue &&
      overLengthValue === UpdatedStoredServices?.current?.OverLengthValue
    ) {
      return true;
    } else return false;
  };
  const CallCarrierRatesApi = () => {
    setReloadQuote(!reloadQuote);
    updateRuntimeState();
    setSelectedIndex(null);

    // handleDisableReQuoteBtn();
  };

  useEffect(() => {
    updateRuntimeState();
  }, []);

  const filter = createFilterOptions();
  const [validationErrors, setValidationErrors] = useState({});
  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [
    destinationphoneNumberValidError,
    setDestinationphoneNumberValidError
  ] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeTabLabel, setActiveTabLabel] = useState('origin');

  const handleMarkAsResolvedReq = rowId => {
    MarkAsResolvedLog(rowId)
      .then(res => {
        res.status === 200 && console.log(res, 'mark as resolved res');
      })
      .catch(err => {
        console.log(err?.message);
      });
  };

  const handlePickupResponse = ApiRes => {
    setPickUpLoader(false);
    if (ApiRes.status === 200) {
      setShipmentBooked(true);
      setPickupReferenceNumber(ApiRes?.data?.data?.referenceNumber);
      failedShip && handleMarkAsResolvedReq(props?.location?.state?.locationId);
      setPickupSuccessRemarks('Your shipment has been booked');
    } else {
      setShipmentFailed(true);
      setShipmentFailedMsg(JSON.stringify(ApiRes?.response?.data));
    }
  };
  const DispatchApiResHandler = ApiRes => {
    setPickUpLoader(false);
    if (ApiRes?.status === 200) {
      setShipmentDispatchMsg(ApiRes?.data?.data?.status);
      setShipmentDispatchFailed(false);
    } else {
      setShipmentDispatchMsg('');
      setShipmentDispatchFailed(true);
    }
  };
  const CallDispatchShipmentApi = () => {
    setPickUpLoader(true);

    const DispatchObj = {
      shipmentId: ApiObjData.shipmentId ? ApiObjData.shipmentId : 0,
      agencyId: AgencyID ? AgencyID : 0,
      type: otherCarrierName ? 1 : 0,
      proNumber: proNumber ? proNumber : '',
      bolNumber: BOLNumber ? BOLNumber : '',
      refNumber: refOrQuoteNmb ? refOrQuoteNmb : '',
      pickupNumber: pickupNumber ? pickupNumber : '',
      carrierId: ApiObjData.carrierId ? ApiObjData.carrierId : 0,
      carrierName:
        carrierName !== null
          ? carrierName.title
          : otherCarrierName
          ? otherCarrierName
          : '',
      driverName: driverName ? driverName : '',
      vehicleNumber: truckNumber ? truckNumber : '',
      phoneNumber: driverNumber ? driverNumber : ''
    };
    DispatchShipment(DispatchObj)
      .then(res => DispatchApiResHandler(res))
      .catch(err => DispatchApiResHandler(err));
  };
  const handleNext = index => {
    let errors = {};

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('User Time Zone:', userTimeZone);

    // Convert PickupDate to user's time zone
    const pickupDate = DateTime.fromISO(originDate, {
      zone: userTimeZone
    }).startOf('day');

    // Current date in user's time zone
    const currentDate = DateTime.now().setZone(userTimeZone).startOf('day');

    if (index === 0 && props?.location?.state?.disptachOpen !== 'Get Quote') {
      if (
        carrierName == null &&
        !otherCarrierName &&
        PreviousProps?.shipmentStatus !== 'Booked'
      ) {
        errors['carrierName'] = 'Select carrier Name';
      } else if (!proNumber && PreviousProps?.shipmentStatus === 'Booked') {
        errors['proNumber'] = 'Enter Pro Number';
      } else if (!refOrQuoteNmb) {
        errors['refOrQuoteNmbErr'] = 'Enter Quote Number';
      } else setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (index === 1) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        console.log(
          selectedCarrierNameQuoteRates,
          'selectedCarrierNameQuoteRates'
        );
        if (!originOpenTimeValue) {
          errors['originOpenTime'] = 'Select pickup open time';
          setValidationErrors(errors);
          return;
        } else if (!originCloseTimeValue) {
          errors['originCloseTime'] = 'Select pickup close time';
          setValidationErrors(errors);
          return;
        }

        // else if (!pickupRemarks) {
        //   errors['pickupRemarks'] = 'Enter pickup remarks';
        // }
        else if (!destinationOpenTimeValue) {
          errors['destinationOpenTime'] = 'Select delivery open time';
          setValidationErrors(errors);
          return;
        } else if (!destinationCloseTimeValue) {
          errors['destinationCloseTime'] = 'Select delivery close time';
          setValidationErrors(errors);
          return;
        }
        // else if (!deliveryRemarks) {
        //   errors['deliveryRemarks'] = 'Enter delivery remarks';
        // }

        const openTime = new Date(`1970-01-01T${originOpenTimeValue}:00`);
        const closeTime = new Date(`1970-01-01T${originCloseTimeValue}:00`);

        if (closeTime < openTime) {
          errors['originCloseTime'] = 'Close time cannot be before open time.';
          setValidationErrors(errors);
          return;
        }
        if (
          selectedCarrierNameQuoteRates === 'SAIA' &&
          pickupRemarks.length > 120
        ) {
          errors['pickupInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }

        if (
          selectedCarrierNameQuoteRates === 'ESTES' &&
          pickupRemarks.length > 256
        ) {
          errors['pickupInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }
        if (
          selectedCarrierNameQuoteRates === 'FedEx' &&
          pickupRemarks.length > 60
        ) {
          errors['pickupInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }

        if (
          selectedCarrierNameQuoteRates === 'Pitt Ohio' &&
          pickupRemarks.length > 254
        ) {
          errors['pickupInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }
        if (
          selectedCarrierNameQuoteRates === 'Pitt Ohio' &&
          deliveryRemarks.length > 254
        ) {
          errors['deliveryInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }
        if (
          (selectedCarrierNameQuoteRates === 'AAA Cooper' ||
            selectedCarrierNameQuoteRates === 'XPO') &&
          pickupRemarks.length > 100
        ) {
          errors['pickupInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }

        const openTimeD = new Date(`1970-01-01T${destinationOpenTimeValue}:00`);
        const closeTimeD = new Date(
          `1970-01-01T${destinationCloseTimeValue}:00`
        );

        if (closeTimeD < openTimeD) {
          errors['destinationCloseTime'] =
            'Close time cannot be before open time.';
          setValidationErrors(errors);
          return;
        }
        if (
          selectedCarrierNameQuoteRates === 'SAIA' &&
          deliveryRemarks.length > 120
        ) {
          errors['deliveryInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }

        if (
          selectedCarrierNameQuoteRates === 'ESTES' &&
          deliveryRemarks.length > 256
        ) {
          errors['deliveryInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }

        if (
          selectedCarrierNameQuoteRates === 'FedEx' &&
          deliveryRemarks.length > 60
        ) {
          errors['deliveryInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        }
        if (
          (selectedCarrierNameQuoteRates === 'AAA Cooper' ||
            selectedCarrierNameQuoteRates === 'XPO') &&
          deliveryRemarks.length > 100
        ) {
          errors['deliveryInstructionsError'] =
            'Maximum characters limit exeeded.';
          setValidationErrors(errors);
          return;
        } else setActiveStep(prevActiveStep => prevActiveStep + 1);
      } else if (!destinationOpenTimeValue) {
        errors['destinationOpenTime'] = 'Select delivery open time';
      } else if (!destinationCloseTimeValue) {
        errors['destinationCloseTime'] = 'Select delivery close time';
      }
      // else if (!deliveryRemarks) {
      //   errors['deliveryRemarks'] = 'Enter delivery remarks';
      // }
      else setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (index === 2 && quickQuoteFlow) {
      if (
        selectedCarrierNameQuoteRates === 'SAIA' ||
        selectedCarrierNameQuoteRates === 'AAA Cooper' ||
        selectedCarrierNameQuoteRates === 'ESTES' ||
        selectedCarrierNameQuoteRates === 'XPO'
      ) {
        if (
          !originName &&
          (selectedCarrierNameQuoteRates === 'ESTES' ||
            selectedCarrierNameQuoteRates === 'SAIA' ||
            selectedCarrierNameQuoteRates === 'AAA Cooper')
        ) {
          errors['originNameError'] = 'Enter origin contact person name';
          enterOriginName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originName.length > 30) {
          errors['originNameError'] =
            'Maximum 30 characters allowed for the Contact person name';
          enterOriginName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!originCompanyName) {
          errors['originCompanyNameError'] = 'Enter origin company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          selectedCarrierNameQuoteRates === 'ESTES' &&
          originCompanyName.length > 450
        ) {
          errors['originCompanyNameError'] =
            'Maximum 450 characters allowed for the company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          originCompanyName.length > 30 &&
          selectedCarrierNameQuoteRates !== 'ESTES'
        ) {
          errors['originCompanyNameError'] =
            'Maximum 30 characters allowed for the company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!originAddress) {
          errors['originStreetError'] = 'Enter street address';
          enterOriginStreet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originAddress.length > 30) {
          errors['originStreetError'] =
            'Maximum 30 characters allowed for street address';
          enterOriginStreet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!phoneNumber) {
          setPhoneNumberValidError(true);
          errors['phoneNumberError'] =
            'Enter Valid Phone Number (XXX) XXX-XXXX';
          enterOriginPhone?.current?.focus();

          setValidationErrors(errors);
          return;
        } else if (!originEmail) {
          errors['originEmailError'] = 'Enter origin email';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (pickupDate < currentDate) {
          errors['PickupDate'] =
            'Please update the PickupDate. It cannot be in the past';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          (selectedCarrierNameQuoteRates === 'AAA Cooper' ||
            selectedCarrierNameQuoteRates === 'ESTES') &&
          originEmail.length > 50
        ) {
          errors['originEmailError'] =
            'Maximum 50 characters allowed for email';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          !destinationName &&
          selectedCarrierNameQuoteRates === 'SAIA'
        ) {
          errors['destinationNameError'] =
            'Enter destination contact person name';
          enterDestinationName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (destinationName.length > 30) {
          errors['destinationNameError'] =
            'Maximum 30 characters allowed for the Contact person name';
          enterDestinationName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!destinationCompanyName) {
          errors['destinationCompanyNameError'] =
            'Enter destination company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          selectedCarrierNameQuoteRates === 'ESTES' &&
          destinationCompanyName.length > 450
        ) {
          errors['destinationCompanyNameError'] =
            'Maximum 450 characters allowed for the company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (
          destinationCompanyName.length > 30 &&
          selectedCarrierNameQuoteRates !== 'ESTES'
        ) {
          errors['destinationCompanyNameError'] =
            'Maximum 30 characters allowed for the company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (destinationAddress.length > 30) {
          errors['destinationAddressError'] =
            'Maximum 30 characters allowed for street address ';
          enterDestinationSteet?.current?.focus();
          setValidationErrors(errors);
          return;
        }
      }
      if (selectedCarrierNameQuoteRates === 'Pitt Ohio') {
        if (!originName) {
          errors['originNameError'] = 'Enter origin contact person name';
          enterOriginName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originName.length > 100) {
          errors['originNameError'] =
            'Maximum 100 characters allowed for the Contact person name';
          enterOriginName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!originCompanyName) {
          errors['originCompanyNameError'] = 'Enter origin company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originCompanyName.length > 100) {
          errors['originCompanyNameError'] =
            'Maximum 100 characters allowed for the company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!originAddress) {
          errors['originStreetError'] = 'Enter street address';
          enterOriginStreet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originAddress.length > 100) {
          errors['originStreetError'] =
            'Maximum 100 characters allowed for street address';
          enterOriginStreet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!phoneNumber) {
          setPhoneNumberValidError(true);
          errors['phoneNumberError'] =
            'Enter Valid Phone Number (XXX) XXX-XXXX';
          enterOriginPhone?.current?.focus();

          setValidationErrors(errors);
          return;
        } else if (!originEmail) {
          errors['originEmailError'] = 'Enter origin email';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (pickupDate < currentDate) {
          errors['PickupDate'] =
            'Please update the PickupDate. It cannot be in the past';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (originEmail.length > 50) {
          errors['originEmailError'] =
            'Maximum 100 characters allowed for email';
          enterOriginEmail?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!destinationName) {
          errors['destinationNameError'] =
            'Enter destination contact person name';
          enterDestinationName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (destinationName.length > 100) {
          errors['destinationNameError'] =
            'Maximum 100 characters allowed for the Contact person name';
          enterDestinationName?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!destinationCompanyName) {
          errors['destinationCompanyNameError'] =
            'Enter destination company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (destinationCompanyName.length > 100) {
          errors['destinationCompanyNameError'] =
            'Maximum 100 characters allowed for the company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!destinationAddress) {
          errors['destinationAddressError'] = 'Enter street address ';
          enterDestinationSteet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (destinationAddress.length > 100) {
          errors['destinationAddressError'] =
            'Maximum 100 characters allowed for street address ';
          enterDestinationSteet?.current?.focus();
          setValidationErrors(errors);
          return;
        }
      } else {
        if (!originCompanyName) {
          errors['originCompanyNameError'] = 'Enter origin company name';
          enterOriginCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!originAddress) {
          errors['originStreetError'] = 'Enter street address';
          enterOriginStreet?.current?.focus();
          setValidationErrors(errors);
          return;
        } else if (!phoneNumber) {
          setPhoneNumberValidError(true);
          errors['phoneNumberError'] =
            'Enter Valid Phone Number (XXX) XXX-XXXX';
          enterOriginPhone?.current?.focus();

          setValidationErrors(errors);
          return;
        } else if (!originEmail) {
          errors['originEmailError'] = 'Enter origin email';
          enterOriginEmail?.current?.focus();

          setValidationErrors(errors);
          return;
        } else if (!destinationCompanyName) {
          errors['destinationCompanyNameError'] =
            'Enter destination company name';
          enterDestinationCompany?.current?.focus();
          setValidationErrors(errors);
          return;
        }
      }

      //

      if (!destinationPhoneNumber) {
        setDestinationphoneNumberValidError(true);
        errors['destinationPhoneNumberError'] =
          'Enter Valid Phone Number (XXX) XXX-XXXX';
        enterDestinationPhone?.current?.focus();
        setValidationErrors(errors);
        return;
      } else if (
        !destinationEmail &&
        selectedCarrierNameQuoteRates !== 'Pitt Ohio'
      ) {
        errors['destinationEmailError'] = 'Enter destination email';
        enterDestinationEmail?.current?.focus();
        setValidationErrors(errors);
        return;
      } else if (
        selectedCarrierNameQuoteRates === 'AAA Cooper' &&
        destinationEmail.length > 50
      ) {
        errors['destinationEmailError'] =
          'Maximum 50 characters allowed for email';
        enterDestinationEmail?.current?.focus();
        setValidationErrors(errors);
        return;
      } else if (!saleOrderNumber) {
        errors['saleOrderNumberError'] = 'Enter sale order number';
        enterSONumbe?.current?.focus();
        setValidationErrors(errors);
        return;
      }
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
    // setSelectedIndex(null);
    // sessionStorage.setItem('updatedStoredServices', null);

    setValidationErrors(errors);
    if (
      props?.location?.state?.rateType !== 'Quick Quote' &&
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      activeStep === 2
    ) {
      CallPickupApi();
    }
    if (
      quickQuoteFlow &&
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      activeStep === 2 &&
      originCompanyName &&
      phoneNumber &&
      originEmail &&
      destinationCompanyName &&
      destinationPhoneNumber &&
      destinationEmail &&
      saleOrderNumber
    ) {
      CallPickupApi();
    }
    if (
      props?.location?.state?.disptachOpen !== 'Get Quote' &&
      stepsArray().length === 2 &&
      index === 1
    ) {
      CallDispatchShipmentApi();
    }
  };

  function getCaseInsensitiveProperty(obj, key) {
    if (!obj || typeof obj !== 'object') return undefined;

    const foundKey = Object.keys(obj).find(
      k => k.toLowerCase() === key.toLowerCase()
    );
    return foundKey ? obj[foundKey] : undefined;
  }

  const handlePickupShipmentReq = newShipId => {
    // pickup through quick quote

    const ManageShipPickupObj = {
      carrier: {
        id: selectedCarrierIDQuoteRates ? selectedCarrierIDQuoteRates : 0,
        name: selectedCarrierNameQuoteRates
          ? selectedCarrierNameQuoteRates
          : '',
        logo: ''
      },
      quotationId: selectedCarrierQuotaionID ? selectedCarrierQuotaionID : '',
      shipmentType: carrierShipType,
      paymentType: failedShip
        ? FailedLogsData?.freightTerms === 'OutboundPrepaid'
          ? '0'
          : FailedLogsData?.freightTerms === 'InboundCollect'
          ? '1'
          : '2'
        : isThirdPartyRate
        ? 'Third Party'
        : props?.location?.state?.paymentType.toString(),
      isHazmat: hazmatSwitch,
      isStablale: stackableSwitch,
      lineItems: failedShip
        ? ApiObjData?.LineItems
        : PreviousProps?.commodityInfo?.map(item => ({
            ...item,
            name: itemDescription,
            description: itemDescription,
            isStackable: item.isStackable
          })),
      shipper: {
        contact: {
          personName: originName,
          phoneNumber: PreviousProps?.destinationContactPhone
            ? PreviousProps?.destinationContactPhone
            : phoneNumber.replace(/\D/g, ''),
          faxNumber: '',
          companyName: PreviousProps?.originCompany
            ? PreviousProps?.originCompany
            : originCompanyName,
          phoneExtension: '',
          email: PreviousProps?.destinationContactEmail
            ? PreviousProps?.destinationContactEmail
            : originEmail
        },
        address: {
          city: PreviousProps?.originCity
            ? PreviousProps?.originCity.trim()
            : PreviousProps?.shipFrom?.city,
          stateOrProvinceCode: PreviousProps?.originState
            ? PreviousProps?.originState
            : PreviousProps?.shipFrom?.stateOrProvinceCode,
          postalCode: PreviousProps?.originZipCode
            ? PreviousProps?.originZipCode
            : PreviousProps?.shipFrom?.postalCode,
          countryCode: PreviousProps?.shipFrom?.countryCode,
          residential: true,
          streetLines: originAddress ? originAddress : ''
          // streetLines: PreviousProps?.originAddress
          //   ? PreviousProps?.originAddress.trim()
          //   : PreviousProps?.shipFrom?.streetLines
        }
      },
      recipient: {
        contact: {
          personName: destinationName,
          phoneNumber: PreviousProps?.originContactPhone
            ? PreviousProps?.originContactPhone
            : destinationPhoneNumber.replace(/\D/g, ''),
          faxNumber: '',
          companyName: PreviousProps?.destinationCompany
            ? PreviousProps?.destinationCompany
            : destinationCompanyName,
          phoneExtension: '',
          email: PreviousProps?.originContactEmail
            ? PreviousProps?.originContactEmail
            : destinationEmail
        },
        address: {
          city: PreviousProps?.destinationCity
            ? PreviousProps?.destinationCity.trim()
            : PreviousProps?.shipTo?.city,
          stateOrProvinceCode: PreviousProps?.destinationState
            ? PreviousProps?.destinationState
            : PreviousProps?.shipTo?.stateOrProvinceCode,
          postalCode: PreviousProps?.destinationZipCode
            ? PreviousProps?.destinationZipCode
            : PreviousProps?.shipTo?.postalCode,
          countryCode: PreviousProps?.shipTo?.countryCode,
          residential: true,
          streetLines: destinationAddress ? destinationAddress : ''

          // streetLines: PreviousProps?.destinationAddress
          //   ? PreviousProps?.destinationAddress.trim()
          //   : PreviousProps?.shipTo?.streetLines
        }
      },
      billTo: {
        contact: {
          personName: '',
          phoneNumber: '',
          faxNumber: '',
          companyName: '',
          phoneExtension: '',
          Email: ''
        },
        address: {
          city: '',
          stateOrProvinceCode: '',
          postalCode: '',
          countryCode: '',
          residential: true,
          streetLines: ''
        }
      },
      originTerminal: {
        contact: {
          personName: originTerminalInfo?.contact?.personName
            ? originTerminalInfo?.contact?.personName
            : '',
          phoneNumber: originTerminalInfo?.contact?.phoneNumber
            ? originTerminalInfo?.contact?.phoneNumber
            : '',
          faxNumber: originTerminalInfo?.contact?.faxNumber
            ? originTerminalInfo?.contact?.faxNumber
            : '',
          companyName: originTerminalInfo?.contact?.companyName
            ? originTerminalInfo?.contact?.companyName
            : '',
          phoneExtension: originTerminalInfo?.contact?.phoneExtension
            ? originTerminalInfo?.contact?.phoneExtension
            : '',
          email: originTerminalInfo?.contact?.email
            ? originTerminalInfo?.contact?.email
            : ''
        },
        address: {
          city: originTerminalInfo?.address?.city
            ? originTerminalInfo?.address?.city
            : '',
          stateOrProvinceCode: originTerminalInfo?.address?.stateOrProvinceCode
            ? originTerminalInfo?.address?.stateOrProvinceCode
            : '',
          postalCode: originTerminalInfo?.address?.postalCode
            ? originTerminalInfo?.address?.postalCode
            : '',
          countryCode: originTerminalInfo?.address?.countryCode
            ? originTerminalInfo?.address?.countryCode
            : '',
          residential: true,
          streetLines: originTerminalInfo?.address?.streetLines
            ? originTerminalInfo?.address?.streetLines
            : ''
        }
      },
      destinationTerminal: {
        contact: {
          personName: destinationTerminalInfo?.contact?.personName
            ? destinationTerminalInfo?.contact?.personName
            : '',
          phoneNumber: destinationTerminalInfo?.contact?.phoneNumber
            ? destinationTerminalInfo?.contact?.phoneNumber
            : '',
          faxNumber: destinationTerminalInfo?.contact?.faxNumber
            ? destinationTerminalInfo?.contact?.faxNumber
            : '',
          companyName: destinationTerminalInfo?.contact?.companyName
            ? destinationTerminalInfo?.contact?.companyName
            : '',
          phoneExtension: destinationTerminalInfo?.contact?.phoneExtension
            ? destinationTerminalInfo?.contact?.phoneExtension
            : '',
          email: destinationTerminalInfo?.contact?.email
            ? destinationTerminalInfo?.contact?.email
            : ''
        },
        address: {
          city: destinationTerminalInfo?.address?.city
            ? destinationTerminalInfo?.address?.city
            : '',
          stateOrProvinceCode: destinationTerminalInfo?.address
            ?.stateOrProvinceCode
            ? destinationTerminalInfo?.address?.stateOrProvinceCode
            : '',
          postalCode: destinationTerminalInfo?.address?.postalCode
            ? destinationTerminalInfo?.address?.postalCode
            : '',
          countryCode: destinationTerminalInfo?.address?.countryCode
            ? destinationTerminalInfo?.address?.countryCode
            : '',
          residential: true,
          streetLines: destinationTerminalInfo?.address?.streetLines
            ? destinationTerminalInfo?.address?.streetLines
            : ''
        }
      },
      instructionForConsignee: deliveryRemarks
        ? cleanHtmlString(deliveryRemarks)
        : '',
      instructionForShipper: pickupRemarks
        ? cleanHtmlString(pickupRemarks)
        : '',
      pickupDate: originDate,
      PickupTime: originOpenTimeValue ? originOpenTimeValue : '',
      requestedDeliveryDate: apiCalDate
        ? apiCalDate
        : new Date().toISOString().split('T')[0],
      // ? formatDate(new Date(selectedDeliveryDate))
      // : formatDate(new Date(calculateFutureDate(transitDays))),
      requestedDeliveryTime: destinationOpenTimeValue
        ? destinationOpenTimeValue
        : '',
      pickupClosingTime: originCloseTimeValue ? originCloseTimeValue : '',
      deliveryStartTime: destinationOpenTimeValue
        ? destinationOpenTimeValue
        : '',
      deliveryEndTime: destinationCloseTimeValue
        ? destinationCloseTimeValue
        : '',
      pickupOptions: {
        inside: insidePickupSwitch,
        liftGateServices: liftgatePickupSwitch,
        residential: residentialPickupSwitch,
        secureAccess: secureAccesPickupSwitch,
        limitedAccess: limitedPickupAccessSwitch,
        freezeProtection: freezeProtectionPickupSwitch,
        overLength: overlengthPickupSwitch,
        overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
        callBeforeDelivery: false
      },
      estimatedTransitDays: transitDays ? transitDays : 0,

      deliveryOptions: {
        inside: insideDeliverySwitch,
        liftGateServices: liftgateDeliverySwitch,
        residential: residentialDeliverySwitch,
        secureAccess: secureAccesDeliverySwitch,
        limitedAccess: limitedDeliverySwitch,
        freezeProtection: false,
        overLength: false,
        overLengthValue: 0,
        callBeforeDelivery: callBeforeDeliveryServicesSwitch
      },
      importIndicator: {
        indicator: '',
        lastFreeday: '',
        paperwork: '',
        airway: {
          bill: '',
          reference: '',
          containerReference: ''
        },
        ocean: {
          bill: '',
          reference: '',
          containerReference: ''
        }
      },
      agencyId: AgencyID ? AgencyID : 0,
      pickupNumber: pickupNumber ? pickupNumber : '',
      proNumber: proNumber ? proNumber : '',
      customerBOLNumber: BOLNumber ? BOLNumber : '',
      referenceNumber: selectedCarrierQuotaionID
        ? selectedCarrierQuotaionID
        : '',
      shipmentId: newShipId,
      locationId: failedShip
        ? FailedLogsData?.locationId
        : props?.location?.state?.locationId,
      quotationCharges: totalNetChargeState,
      serviceType: serviceTypeApi ? serviceTypeApi : '',
      surcharges: surchargesArr
    };
    console.log(ManageShipPickupObj, 'ManageShipPickupObj');
    PickupShipment(ManageShipPickupObj)
      .then(res => handlePickupResponse(res))
      .catch(err => handlePickupResponse(err));
  };
  const CallPickupApi = () => {
    const PickUpDate = new Date(PreviousProps?.pickupDate).toLocaleDateString(
      'zh-Hans-CN'
    );

    const DekiveryDate = new Date(
      PreviousProps?.deliveryDate
    ).toLocaleDateString('zh-Hans-CN');

    const ModifiedPickUpDate = PickUpDate.replace(/\//g, '-');
    const ModifiedDeliveryDate = DekiveryDate.replace(/\//g, '-');
    // direct pickup through shipments
    let ManageShipPickupObj = {
      carrier: {
        id: selectedCarrierIDQuoteRates ? selectedCarrierIDQuoteRates : 0,
        name: selectedCarrierNameQuoteRates
          ? selectedCarrierNameQuoteRates
          : '',
        logo: ''
      },
      quotationId: selectedCarrierQuotaionID ? selectedCarrierQuotaionID : '',
      shipmentType: carrierShipType,
      paymentType: failedShip
        ? FailedLogsData?.freightTerms === 'OutboundPrepaid'
          ? '0'
          : FailedLogsData?.freightTerms === 'InboundCollect'
          ? '1'
          : '2'
        : isThirdPartyRate
        ? 'Third Party'
        : props?.location?.state?.paymentType.toString(),
      isHazmat: hazmatSwitch,
      isStablale: stackableSwitch,
      lineItems: [
        {
          freightClass: PreviousProps?.details?.[0]?.freightClass
            ? PreviousProps?.details?.[0]?.freightClass
            : '',
          packaging: PreviousProps?.details?.[0]?.packagingType
            ? PreviousProps?.details?.[0]?.packagingType
            : '',

          units: PreviousProps?.details?.[0]?.units
            ? PreviousProps?.details?.[0]?.units
            : 1,
          pieces: PreviousProps?.details?.[0]?.pieces
            ? PreviousProps?.details?.[0]?.pieces
            : 1,
          // pallets: PreviousProps?.details?.[0]?.pallets
          //   ? PreviousProps?.details?.[0]?.pallets
          //   : 1,

          weight: {
            units: 'lbs',
            value: PreviousProps?.details?.[0]?.grossWeight
              ? PreviousProps?.details?.[0]?.grossWeight
              : 1
          },
          nmfc: PreviousProps?.details?.[0]?.nmfc
            ? PreviousProps?.details?.[0]?.nmfc
            : '',
          dimensions: {
            length: 0,
            width: 0,
            height: 0,
            dimensionsUom: 'cm'
          },
          isStackable: stackableSwitch,
          description: itemDescription
        }
      ],
      shipper: {
        contact: {
          personName: originName,
          phoneNumber: PreviousProps?.destinationContactPhone
            ? PreviousProps?.destinationContactPhone
            : '',
          faxNumber: '',
          companyName: PreviousProps?.originCompany
            ? PreviousProps?.originCompany
            : originCompanyName,
          phoneExtension: '',
          email: PreviousProps?.destinationContactEmail
            ? PreviousProps?.destinationContactEmail
            : ''
        },
        address: {
          city: PreviousProps?.originCity
            ? PreviousProps?.originCity.trim()
            : PreviousProps?.shipFrom?.city,
          stateOrProvinceCode: PreviousProps?.originState
            ? PreviousProps?.originState
            : PreviousProps?.shipFrom?.stateOrProvinceCode,
          postalCode: PreviousProps?.originZipCode
            ? PreviousProps?.originZipCode
            : PreviousProps?.shipFrom?.postalCode,
          countryCode: PreviousProps?.originCountry,
          residential: true,
          streetLines: PreviousProps?.originAddress
            ? PreviousProps?.originAddress.trim()
            : PreviousProps?.shipFrom?.streetLines
        }
      },
      recipient: {
        contact: {
          personName: destinationName,
          phoneNumber: PreviousProps?.originContactPhone
            ? PreviousProps?.originContactPhone
            : '',
          faxNumber: '',
          companyName: PreviousProps?.destinationCompany
            ? PreviousProps?.destinationCompany
            : destinationCompanyName,
          phoneExtension: '',
          email: PreviousProps?.originContactEmail
            ? PreviousProps?.originContactEmail
            : ''
        },
        address: {
          city: PreviousProps?.destinationCity
            ? PreviousProps?.destinationCity.trim()
            : PreviousProps?.shipTo?.city,
          stateOrProvinceCode: PreviousProps?.destinationState
            ? PreviousProps?.destinationState
            : PreviousProps?.shipTo?.stateOrProvinceCode,
          postalCode: PreviousProps?.destinationZipCode
            ? PreviousProps?.destinationZipCode
            : PreviousProps?.shipTo?.postalCode,
          countryCode: PreviousProps?.destinationCountry,
          residential: true,
          streetLines: PreviousProps?.destinationAddress
            ? PreviousProps?.destinationAddress.trim()
            : PreviousProps?.shipTo?.streetLines
        }
      },
      billTo: {
        contact: {
          personName: PreviousProps?.billToContactPerson
            ? PreviousProps?.billToContactPerson
            : '',
          phoneNumber: PreviousProps?.billToContactPhone
            ? PreviousProps?.billToContactPhone
            : '',
          faxNumber: '',
          companyName: PreviousProps?.billToCompany
            ? PreviousProps?.billToCompany
            : '',
          phoneExtension: '',
          email: PreviousProps?.billToContactEmail
            ? PreviousProps?.billToContactEmail
            : ''
        },
        address: {
          city: PreviousProps?.billToCity ? PreviousProps?.billToCity : '',
          stateOrProvinceCode: PreviousProps?.billToState
            ? PreviousProps?.billToState
            : '',
          postalCode: PreviousProps?.billToZipCode
            ? PreviousProps?.billToZipCode
            : '',
          countryCode: PreviousProps?.billToCountry
            ? PreviousProps?.billToCountry
            : '',
          residential: true,
          streetLines: PreviousProps?.billToAddress
            ? PreviousProps?.billToAddress
            : ''
        }
      },
      originTerminal: {
        contact: {
          personName: originTerminalInfo?.contact?.personName
            ? originTerminalInfo?.contact?.personName
            : '',
          phoneNumber: originTerminalInfo?.contact?.phoneNumber
            ? originTerminalInfo?.contact?.phoneNumber
            : '',
          faxNumber: originTerminalInfo?.contact?.faxNumber
            ? originTerminalInfo?.contact?.faxNumber
            : '',
          companyName: originTerminalInfo?.contact?.companyName
            ? originTerminalInfo?.contact?.companyName
            : '',
          phoneExtension: originTerminalInfo?.contact?.phoneExtension
            ? originTerminalInfo?.contact?.phoneExtension
            : '',
          email: originTerminalInfo?.contact?.email
            ? originTerminalInfo?.contact?.email
            : ''
        },
        address: {
          city: originTerminalInfo?.address?.city
            ? originTerminalInfo?.address?.city
            : '',
          stateOrProvinceCode: originTerminalInfo?.address?.stateOrProvinceCode
            ? originTerminalInfo?.address?.stateOrProvinceCode
            : '',
          postalCode: originTerminalInfo?.address?.postalCode
            ? originTerminalInfo?.address?.postalCode
            : '',
          countryCode: originTerminalInfo?.address?.countryCode
            ? originTerminalInfo?.address?.countryCode
            : '',
          residential: true,
          streetLines: originTerminalInfo?.address?.streetLines
            ? originTerminalInfo?.address?.streetLines
            : ''
        }
      },
      destinationTerminal: {
        contact: {
          personName: destinationTerminalInfo?.contact?.personName
            ? destinationTerminalInfo?.contact?.personName
            : '',
          phoneNumber: destinationTerminalInfo?.contact?.phoneNumber
            ? destinationTerminalInfo?.contact?.phoneNumber
            : '',
          faxNumber: destinationTerminalInfo?.contact?.faxNumber
            ? destinationTerminalInfo?.contact?.faxNumber
            : '',
          companyName: destinationTerminalInfo?.contact?.companyName
            ? destinationTerminalInfo?.contact?.companyName
            : '',
          phoneExtension: destinationTerminalInfo?.contact?.phoneExtension
            ? destinationTerminalInfo?.contact?.phoneExtension
            : '',
          email: destinationTerminalInfo?.contact?.email
            ? destinationTerminalInfo?.contact?.email
            : ''
        },
        address: {
          city: destinationTerminalInfo?.address?.city
            ? destinationTerminalInfo?.address?.city
            : '',
          stateOrProvinceCode: destinationTerminalInfo?.address
            ?.stateOrProvinceCode
            ? destinationTerminalInfo?.address?.stateOrProvinceCode
            : '',
          postalCode: destinationTerminalInfo?.address?.postalCode
            ? destinationTerminalInfo?.address?.postalCode
            : '',
          countryCode: destinationTerminalInfo?.address?.countryCode
            ? destinationTerminalInfo?.address?.countryCode
            : '',
          residential: true,
          streetLines: destinationTerminalInfo?.address?.streetLines
            ? destinationTerminalInfo?.address?.streetLines
            : ''
        }
      },
      instructionForConsignee: deliveryRemarks
        ? cleanHtmlString(deliveryRemarks)
        : '',
      instructionForShipper: pickupRemarks
        ? cleanHtmlString(pickupRemarks)
        : '',
      pickupDate: PreviousProps?.pickupDate ? ModifiedPickUpDate : '',
      PickupTime: originOpenTimeValue ? originOpenTimeValue : '',
      requestedDeliveryDate: apiCalDate
        ? apiCalDate
        : new Date().toISOString().split('T')[0],
      requestedDeliveryTime: destinationOpenTimeValue
        ? destinationOpenTimeValue
        : '',
      pickupClosingTime: originCloseTimeValue ? originCloseTimeValue : '',
      deliveryStartTime: destinationOpenTimeValue
        ? destinationOpenTimeValue
        : '',
      deliveryEndTime: destinationCloseTimeValue
        ? destinationCloseTimeValue
        : '',
      pickupOptions: {
        inside: insidePickupSwitch,
        liftGateServices: liftgatePickupSwitch,
        residential: residentialPickupSwitch,
        secureAccess: secureAccesPickupSwitch,
        limitedAccess: limitedPickupAccessSwitch,
        freezeProtection: freezeProtectionPickupSwitch,
        overLength: overlengthPickupSwitch,
        overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
        callBeforeDelivery: false
      },
      estimatedTransitDays: transitDays ? transitDays : 0,

      deliveryOptions: {
        inside: insideDeliverySwitch,
        liftGateServices: liftgateDeliverySwitch,
        residential: residentialDeliverySwitch,
        secureAccess: secureAccesDeliverySwitch,
        limitedAccess: limitedDeliverySwitch,
        freezeProtection: false,
        overLength: false,
        overLengthValue: 0,
        callBeforeDelivery: callBeforeDeliveryServicesSwitch
      },
      importIndicator: {
        indicator: '',
        lastFreeday: '',
        paperwork: '',
        airway: {
          bill: '',
          reference: '',
          containerReference: ''
        },
        ocean: {
          bill: '',
          reference: '',
          containerReference: ''
        }
      },
      agencyId: AgencyID ? AgencyID : 0,
      pickupNumber: pickupNumber ? pickupNumber : '',
      proNumber: proNumber ? proNumber : '',
      customerBOLNumber: BOLNumber ? BOLNumber : '',
      referenceNumber: selectedCarrierQuotaionID
        ? selectedCarrierQuotaionID
        : '',
      shipmentId: quickQuoteFlow
        ? shipmentId
        : PreviousProps?.shipmentId
        ? PreviousProps?.shipmentId
        : 0,
      locationId: failedShip
        ? FailedLogsData?.locationId
        : props?.location?.state?.locationId,
      quotationCharges: totalNetChargeState,
      serviceType: serviceTypeApi ? serviceTypeApi : '',

      surcharges: surchargesArr
    };

    if (quickQuoteFlow) {
      const detailsArr = failedShip
        ? ApiObjData?.LineItems
        : PreviousProps?.commodityInfo;
      // const updatedItems =detailsArr.map(
      //   ({
      //     freightClass,
      //     nmfc,
      //     packaging,
      //     pieces,
      //     units,
      //     weight,
      //     dimensions,
      //     StackAble,
      //     isStackable
      //   }) => ({
      //     ItemText: itemDescription,
      //     freightClass,
      //     NMFCClass: '',
      //     packagingType: packaging ? packaging : '',
      //     requestedQuantity: pieces,
      //     pallets: units,
      //     netWeight: weight.value,
      //     grossWeight: weight.value,
      //     length: parseInt(dimensions.length),
      //     width: parseInt(dimensions.width),
      //     height: parseInt(dimensions.height),
      //     isStackable: isStackable
      //   })
      // );
      const updatedItems = detailsArr.map(item => ({
        ItemText: itemDescription,
        freightClass: failedShip ? item.FreightClass : item.freightClass,
        NMFCClass: failedShip ? item.NMFC : item.nmfc || '',
        packagingType: failedShip ? item.Packaging : item.packaging || '',
        requestedQuantity: failedShip ? item.Pieces : item.pieces,
        pallets: failedShip ? item.Units : item.units,
        netWeight: failedShip ? item.Weight?.Value : item.weight?.value || 0,
        grossWeight: failedShip ? item.Weight?.Value : item.weight?.value || 0,
        length:
          parseInt(
            failedShip ? item.Dimensions?.length : item.dimensions?.length
          ) || 0,
        width:
          parseInt(
            failedShip ? item.Dimensions?.width : item.dimensions?.width
          ) || 0,
        height:
          parseInt(
            failedShip ? item.Dimensions?.height : item.dimensions?.height
          ) || 0,
        isStackable: failedShip ? item.IsStackable : item.isStackable
      }));

      const saveShipmentObj = {
        orderDate: new Date().toISOString().split('T')[0],
        pickupDate: originDate,
        pickupNumber: '',
        expectedDeliveryDate: apiCalDate
          ? apiCalDate
          : new Date().toISOString().split('T')[0],
        // ? formatDate(new Date(selectedDeliveryDate))
        // : formatDate(new Date(calculateFutureDate(transitDays))),
        originCompany: originCompanyName,
        originAddress: originAddress,
        originCity: PreviousProps?.shipFrom?.city,
        originState: PreviousProps?.shipFrom?.stateOrProvinceCode,
        originZip: PreviousProps?.shipFrom?.postalCode,
        originCountry: PreviousProps?.shipFrom?.countryCode,
        originContactPerson: originName,
        originContactEmail: originEmail,
        originContactPhone: phoneNumber,
        destinationCompany: destinationCompanyName,
        destinationAddress: destinationAddress,
        destinationCity: PreviousProps?.shipTo?.city,
        destinationState: PreviousProps?.shipTo?.stateOrProvinceCode,
        destinationZip: PreviousProps?.shipTo?.postalCode,
        destinationCountry: PreviousProps?.shipTo?.countryCode,
        destinationContactPerson: destinationName,
        destinationContactEmail: destinationEmail,
        destinationContactPhone: destinationPhoneNumber,
        billToCompany: '',
        billToAddress: '',
        billToCity: '',
        billToState: '',
        billToZip: '',
        billToCountry: '',
        billToContactPerson: '',
        billToContactEmail: '',
        billToContactPhone: '',
        shipmentType: carrierShipType,
        equipmentType: '',
        freightTerms: isThirdPartyRate
          ? 'ThirdParty'
          : PreviousProps?.paymentType === '0'
          ? 'OutboundPrepaid'
          : PreviousProps?.paymentType === '1'
          ? 'InboundCollect'
          : 'ThirdParty',
        customerId: '',
        salesOrderNumber: saleOrderNumber,
        purchaseOrderNumber: customerPoNmb,
        freightInvoiceNumber: '',
        carrierId: selectedCarrierIDQuoteRates,
        carrierName: selectedCarrierNameQuoteRates,
        paymentTerms: '',
        shipmentStatus: 'Saved',
        DeliveryLineItems: [],
        PickupLineItems: updatedItems,
        bolNumber: '',
        shippingNotes: pickupRemarks,
        proNumber: '',
        locationId: PreviousProps?.locationId,
        pickupStartTime: originOpenTimeValue,
        pickupEndTime: originCloseTimeValue,
        deliverStartTime: destinationOpenTimeValue,
        deliverEndTime: destinationCloseTimeValue,
        shipmentCharges: totalNetChargeState,
        actualPickupDate: originDate,
        actualDeliveryDate: apiCalDate
          ? apiCalDate
          : new Date().toISOString().split('T')[0],
        // ? formatDate(new Date(selectedDeliveryDate))
        // : formatDate(new Date(calculateFutureDate(transitDays))),
        quoteNumber: selectedCarrierQuotaionID ? selectedCarrierQuotaionID : '',
        serviceType: serviceTypeApi ? serviceTypeApi : '',
        location: failedShip
          ? FailedLogsData?.locationName
          : PreviousProps?.locationFull,
        totalGrossWeight: PreviousProps?.commodityInfo?.reduce(
          (total, item) => {
            return total + parseFloat(item?.weight?.value || 0);
          },
          0
        ),
        totalNetWeight: PreviousProps?.commodityInfo?.reduce((total, item) => {
          return total + parseFloat(item?.weight?.value || 0);
        }, 0),
        originTerminalAddress: originTerminalInfo?.address?.streetLines
          ? originTerminalInfo?.address?.streetLines
          : '',
        originTerminalCity: originTerminalInfo?.address?.city
          ? originTerminalInfo?.address?.city
          : '',
        originTerminalState: originTerminalInfo?.address?.stateOrProvinceCode
          ? originTerminalInfo?.address?.stateOrProvinceCode
          : '',
        originTerminalPostalCode: originTerminalInfo?.address?.postalCode
          ? originTerminalInfo?.address?.postalCode
          : '',
        originTerminalCountry: originTerminalInfo?.address?.countryCode
          ? originTerminalInfo?.address?.countryCode
          : '',
        originTerminalContact: originTerminalInfo?.contact?.personName
          ? originTerminalInfo?.contact?.personName
          : '',
        originTerminalContantEmail: originTerminalInfo?.contact?.email
          ? originTerminalInfo?.contact?.email
          : '',
        originTerminalContactPhone: originTerminalInfo?.contact?.phoneNumber
          ? originTerminalInfo?.contact?.phoneNumber
          : '',
        destinationTerminalAddress: destinationTerminalInfo?.address
          ?.streetLines
          ? destinationTerminalInfo?.address?.streetLines
          : '',
        destinationTerminalCity: destinationTerminalInfo?.address?.city
          ? destinationTerminalInfo?.address?.city
          : '',
        destinationTerminalState: destinationTerminalInfo?.address
          ?.stateOrProvinceCode
          ? destinationTerminalInfo?.address?.stateOrProvinceCode
          : '',
        destinationTerminalPostalCode: destinationTerminalInfo?.address
          ?.postalCode
          ? destinationTerminalInfo?.address?.postalCode
          : '',
        destinationTerminalCountry: destinationTerminalInfo?.address
          ?.countryCode
          ? destinationTerminalInfo?.address?.countryCode
          : '',
        destinationTerminalContact: destinationTerminalInfo?.contact?.personName
          ? destinationTerminalInfo?.contact?.personName
          : '',
        destinationTerminalContantEmail: destinationTerminalInfo?.contact?.email
          ? destinationTerminalInfo?.contact?.email
          : '',
        destinationTerminalContactPhone: destinationTerminalInfo?.contact
          ?.phoneNumber
          ? destinationTerminalInfo?.contact?.phoneNumber
          : '',
        estimatedTransitDays: transitDays ? transitDays : 0,
        shipmentMiles: shipmentMiles,
        leastCostCarrier: lowestCostCarrierID,
        leastCost: lowestCostCarrier,
        leastCostAgencySurcharge: leastCostAgencySurcharge,
        leastTransitCarrier: lowestCostCarrierID,
        leastTransitDays: quickestCarrier,
        isHazmat: hazmatSwitch,
        pickupOptions: {
          inside: insidePickupSwitch,
          liftGateServices: liftgatePickupSwitch,
          residential: residentialPickupSwitch,
          secureAccess: secureAccesPickupSwitch,
          limitedAccess: limitedPickupAccessSwitch,
          freezeProtection: freezeProtectionPickupSwitch,
          overLength: overlengthPickupSwitch,
          overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
          callBeforeDelivery: false
        },
        deliveryOptions: {
          inside: insideDeliverySwitch,
          liftGateServices: liftgateDeliverySwitch,
          residential: residentialDeliverySwitch,
          secureAccess: secureAccesDeliverySwitch,
          limitedAccess: limitedDeliverySwitch
        },
        details: updatedItems
      };
      setPickUpLoader(true);
      CreateShipment(saveShipmentObj)
        .then(res => {
          res.status === 200 && handlePickupShipmentReq(res.data.data);
        })
        .catch(err => {
          setPickUpLoader(false);
          // handleBack();
          ErrorToast(
            `Create Shipment API failed due to, ${
              err?.response?.data ? err?.response?.data : err?.message
            }`
          );
          console.log(err, 'Create SHipment Error_____________>>>>');
        });
    } else {
      setPickUpLoader(true);
      PickupShipment(ManageShipPickupObj)
        .then(res => handlePickupResponse(res))
        .catch(err => handlePickupResponse(err));
    }
  };
  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const PaymentTypeArr = ['Outbound Prepaid', 'Third Party'];
  const HazmatOptions = ['No', 'Yes'];
  const [hazmatType, setHazmatType] = useState(HazmatOptions[0]);
  const [paymentType, setPaymentType] = useState(PreviousProps?.paymentTerms);

  const handleClassInputChange = (inputName, index, event) => {
    let totalWeight = 0;
    let TotalWeightSum;
    const values = [...newAddedClassRow];
    if (inputName === 'WeightLBS') {
      // const updatedErrors = { ...validationErrors, weightLBS: null };
      // setValidationErrors(updatedErrors);

      values[index].WeightLBS = event.target.value;

      // alert('karam');
      for (let index = 0; index < newAddedClassRow.length; index++) {
        if (newAddedClassRow[index].WeightLBS !== '') {
          totalWeight += parseInt(newAddedClassRow[index].WeightLBS);
        }
      }
      setTotalLBSWeightClass(totalWeight);
      TotalWeightSum = totalLBSWeightDimensions
        ? parseInt(totalLBSWeightDimensions) + totalWeight
        : totalWeight;
      setTotalWeightSum(TotalWeightSum);
      handlePushAddedCommodityInfo(TotalWeightSum);
    } else if (inputName === 'NMFCnumber') {
      values[index].NMFCnumber = event.target.value;
    } else if (inputName === 'Class') {
      values[index].Class = event === null ? ClassArray[0] : event;
    }

    setNewAddedClassRow(values);
  };

  //   if (name === 'OriginOpenTime') {
  //     setOriginOpenTimeValue(event.target.value);
  //     const AMPM = event.target.value.split(':');
  //     setOriginOpenTimeFormate(parseInt(AMPM[0]) < 12 ? 'AM' : 'PM');
  //   } else if (name === 'OriginCloseTime') {
  //     setOriginCloseTimeValue(event.target.value);
  //     const AMPM = event.target.value.split(':');
  //     setOriginCloseTimeFormate(parseInt(AMPM[0]) < 12 ? 'AM' : 'PM');
  //   } else if (name === 'DestiOpenTime') {
  //     setDestinationOpenTimeValue(event.target.value);
  //     const AMPM = event.target.value.split(':');
  //     setDestinationOpenTimeFormate(parseInt(AMPM[0]) < 12 ? 'AM' : 'PM');
  //   } else {
  //     setDestinationCloseTimeValue(event.target.value);
  //     const AMPM = event.target.value.split(':');
  //     setDestinationCloseTimeFormate(parseInt(AMPM[0]) < 12 ? 'AM' : 'PM');
  //   }
  // };
  const handleTimeChange = (newValue, name) => {
    if (name === 'OriginOpenTime') {
      setOriginOpenTimeValue(newValue.format('HH:mm'));
    } else if (name === 'OriginCloseTime') {
      setOriginCloseTimeValue(newValue.format('HH:mm'));
    } else if (name === 'DestiOpenTime') {
      setDestinationOpenTimeValue(newValue.format('HH:mm'));
    } else {
      setDestinationCloseTimeValue(newValue.format('HH:mm'));
    }
  };
  // const [value, setValue] = useState(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  const handlePhoneNumberPaste = event => {
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the pasted text from clipboard
    const pastedText = event.clipboardData.getData('text/plain');

    // Remove non-numeric characters from pasted text
    const cleanedText = pastedText.replace(/\D/g, '');

    // Apply formatting logic
    const formattedValue = cleanedText.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3'
    );
    setDriverNumber(formattedValue);

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberError: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const handleCarrierPhoneNumberPaste = (event, type) => {
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the pasted text from clipboard
    const pastedText = event.clipboardData.getData('text/plain');

    // Remove non-numeric characters from pasted text
    const cleanedText = pastedText.replace(/\D/g, '');

    // Apply formatting logic
    const formattedValue = cleanedText.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3'
    );
    console.log(formattedValue, 'formattedValue');
    type === 'originPhone'
      ? setPhoneNumber(formattedValue)
      : setDestinationPhoneNumber(formattedValue);

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setDestinationphoneNumberValidError(false);
      setValidationErrors({
        ...validationErrors,
        phoneNumberError: null,
        destinationPhoneNumberError: null
      });
    } else if (type === 'originPhone') {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    } else {
      setDestinationphoneNumberValidError(true);
      errors['destinationPhoneNumberError'] =
        'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
    setSkipNextChange(true);
    setTimeout(() => setSkipNextChange(false), 0);
  };
  const handleCarrierPhoneNumberChange = (event, type) => {
    if (skipNextChange) return;
    const inputValue = event.target.value;
    // Remove non-numeric characters and retain formatting

    if (type === 'origin') {
      const formattedValue = inputValue
        .replace(/\D/g, '')
        .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
      setPhoneNumber(formattedValue);

      // Perform validation on the formatted value
      const errors = {};
      const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
      const isValidPhoneNumber = phoneRegex.test(formattedValue);
      if (isValidPhoneNumber) {
        setPhoneNumberValidError(false);
        setValidationErrors({ ...validationErrors, phoneNumberError: null });
      } else {
        setPhoneNumberValidError(true);
        errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
        setValidationErrors(errors);
      }
    } else {
      const formattedValue = inputValue
        .replace(/\D/g, '')
        .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
      setDestinationPhoneNumber(formattedValue);

      // Perform validation on the formatted value
      const errors = {};
      const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
      const isValidPhoneNumber = phoneRegex.test(formattedValue);
      if (isValidPhoneNumber) {
        setDestinationphoneNumberValidError(false);
        setValidationErrors({
          ...validationErrors,
          destinationPhoneNumberError: null
        });
      } else {
        setDestinationphoneNumberValidError(true);
        errors['destinationPhoneNumberError'] =
          'Enter Valid Phone Number (XXX) XXX-XXXX';
        setValidationErrors(errors);
      }
    }
  };

  const handleDateTimeShow = (timeStamp, type) => {
    if (timeStamp !== null) {
      const dateTimeString = timeStamp + 'Z';
      const dateTime = new Date(dateTimeString);
      const date = new Date(dateTimeString);
      // const timeOptions = {
      //   hour: 'numeric',
      //   minute: '2-digit',
      //   // second: '2-digit',
      //   hour12: true,
      //   weekday: 'short',
      //   // year: 'numeric',
      //   month: 'short',
      //   day: 'numeric'
      // };
      const dateOptions = {
        // weekday: 'short',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      };

      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const timeOptions = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: userTimeZone
      }).format(dateTime);

      const formattedTime = dateTime.toLocaleTimeString(undefined, timeOptions);
      const formattedDate = date.toLocaleDateString(undefined, dateOptions);

      if (type === 'time') {
        return timeOptions;
      }
      if (type === 'date') {
        return formattedDate;
      }
    }
  };
  const shipFromAddress = () => {
    return failedShip
      ? ApiObjData?.Shipper?.Address?.City +
          ' ' +
          ApiObjData?.Shipper?.Address?.StateOrProvinceCode +
          ' ' +
          ApiObjData?.Shipper?.Address?.PostalCode +
          ' ' +
          ApiObjData?.Shipper?.Address?.CountryCode
      : quickQuoteFlow
      ? PreviousProps?.shipFrom?.city +
        ' ' +
        PreviousProps?.shipFrom?.stateOrProvinceCode +
        ' ' +
        PreviousProps?.shipFrom?.postalCode +
        ' ' +
        PreviousProps?.shipFrom?.countryCode
      : PreviousProps?.originCity +
        ' ' +
        PreviousProps?.originState +
        ' ' +
        PreviousProps?.originZipCode;
  };

  const shipToAddress = () => {
    return failedShip
      ? ApiObjData?.Recipient?.Address?.City +
          ' ' +
          ApiObjData?.Recipient?.Address?.StateOrProvinceCode +
          ' ' +
          ApiObjData?.Recipient?.Address?.PostalCode +
          ' ' +
          ApiObjData?.Recipient?.Address?.CountryCode
      : quickQuoteFlow
      ? PreviousProps?.shipTo?.city +
        ' ' +
        PreviousProps?.shipTo?.stateOrProvinceCode +
        ' ' +
        PreviousProps?.shipTo?.postalCode +
        ' ' +
        PreviousProps?.shipTo?.countryCode
      : PreviousProps?.destinationCity +
        ' ' +
        PreviousProps?.destinationState +
        ' ' +
        PreviousProps?.destinationZipCode;
  };

  const paymentTypeValue = () => {
    return failedShip
      ? ApiObjData?.PaymentType === '0'
        ? 'Outbound'
        : ApiObjData?.PaymentType === '1'
        ? 'Inbound'
        : 'Third Party'
      : quickQuoteFlow
      ? isThirdPartyRate
        ? 'Third Party'
        : PreviousProps?.paymentType === '0'
        ? 'Outbound'
        : PreviousProps?.paymentType === '1'
        ? 'Inbound'
        : 'Third Party'
      : PreviousProps?.freightTerms;
  };
  const handleStepperContent = (index, label) => {
    if (index === 0) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        const RatesObj = ApiObjData;
        let obj = quickQuoteFlow
          ? {
              ...RatesObj, // Keep all existing values
              pickupOptions: {
                ...RatesObj.pickupOptions, // Keep existing pickupOptions values
                inside: insidePickupSwitch,
                liftGateServices: liftgatePickupSwitch,
                residential: residentialPickupSwitch,
                secureAccess: secureAccesPickupSwitch,
                limitedAccess: limitedPickupAccessSwitch,
                freezeProtection: freezeProtectionPickupSwitch,
                overLength: overlengthPickupSwitch,
                overLengthValue: overLengthValue
                  ? parseFloat(overLengthValue)
                  : 0,
                callBeforeDelivery: false
              },
              deliveryOptions: {
                ...RatesObj.deliveryOptions, // Keep existing deliveryOptions values
                inside: insideDeliverySwitch,
                liftGateServices: liftgateDeliverySwitch,
                residential: residentialDeliverySwitch,
                secureAccess: secureAccesDeliverySwitch,
                limitedAccess: limitedDeliverySwitch,
                freezeProtection: false,
                overLength: false,
                overLengthValue: 0,
                callBeforeDelivery: callBeforeDeliveryServicesSwitch
              },
              codAmount: CODAmount ? parseInt(CODAmount) : RatesObj.codAmount, // Keep original if not provided
              declaredValue: DeclaredValue
                ? parseInt(DeclaredValue)
                : RatesObj.declaredValue, // Keep original if not provided
              isHazmat:
                hazmatSwitch !== undefined ? hazmatSwitch : RatesObj.isHazmat // Keep original if not provided
            }
          : {
              shipmentType: carrierShipType,
              location: RatesObj?.locationName ? RatesObj?.locationName : '',
              paymentType: failedShip
                ? FailedLogsData?.freightTerms
                : isThirdPartyRate
                ? 'Third Party'
                : props?.location?.state.paymentType.toString(),
              shipFrom: {
                city: RatesObj?.originCity?.trim(),
                stateOrProvinceCode: RatesObj?.originState?.trim(),
                postalCode: RatesObj?.originZipCode,
                countryCode: RatesObj?.originCountry,
                residential: true,
                streetLines: RatesObj?.originAddress?.trim()
              },
              shipTo: {
                city: RatesObj?.destinationCity?.trim(),
                stateOrProvinceCode: RatesObj?.destinationState?.trim(),
                postalCode: RatesObj?.destinationZipCode,
                countryCode: RatesObj?.destinationCountry,
                residential: true,
                streetLines: RatesObj?.destinationAddress?.trim()
              },
              shipmentDate: new Date().toISOString().split('T')[0],
              isHazmat: hazmatSwitch,
              commodityInfo: [
                {
                  freightClass: '50',
                  packaging: RatesObj?.details[0]?.packagingType,
                  pieces: RatesObj?.details[0]?.pallets,
                  weight: {
                    units: 'lbs',
                    value: RatesObj?.details[0]?.grossWeight
                  },
                  nmfc: RatesObj?.details[0]?.itemNumber,
                  isStackable: false,
                  dimensions: {
                    length: 0,
                    width: 0,
                    height: 0,
                    dimensionsUom: 'inches'
                  }
                }
              ],
              estimatedTransitDays: transitDays ? transitDays : 0,
              shipmentMiles: shipmentMiles,
              leastCostCarrier: lowestCostCarrierID,
              leastCost: lowestCostCarrier,
              leastCostAgencySurcharge: leastCostAgencySurcharge,
              leastTransitCarrier: lowestCostCarrierID,
              leastTransitDays: quickestCarrier,

              pickupOptions: {
                inside: insidePickupSwitch,
                liftGateServices: liftgatePickupSwitch,
                residential: residentialPickupSwitch,
                secureAccess: secureAccesPickupSwitch,
                limitedAccess: limitedPickupAccessSwitch,
                freezeProtection: freezeProtectionPickupSwitch,
                overLength: overlengthPickupSwitch,
                overLengthValue: overLengthValue
                  ? parseFloat(overLengthValue)
                  : 0,
                callBeforeDelivery: false
              },
              deliveryOptions: {
                inside: insideDeliverySwitch,
                liftGateServices: liftgateDeliverySwitch,
                residential: residentialDeliverySwitch,
                secureAccess: secureAccesDeliverySwitch,
                limitedAccess: limitedDeliverySwitch,
                freezeProtection: false,
                overLength: false,
                overLengthValue: 0,
                callBeforeDelivery: callBeforeDeliveryServicesSwitch
              },
              codAmount: CODAmount ? parseInt(CODAmount) : 0,
              declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
              agencyId: AgencyID ? AgencyID : 0,
              locationId: failedShip
                ? FailedLogsData?.locationId
                : props?.location?.state?.locationId,
              isGuaranteed: false
            };
        let deepClone = JSON.parse(JSON.stringify(obj));

        if (
          RatesObj?.packagingType === 'Pallet' ||
          RatesObj?.packagingType === 'Drum' ||
          RatesObj?.packagingType === 'Box'
        ) {
          deepClone.commodityInfo[0].dimensions.length = 48;
          deepClone.commodityInfo[0].dimensions.width = 40;
          deepClone.commodityInfo[0].dimensions.height = 72;
        }
        if (RatesObj?.packagingType === 'Tote') {
          deepClone.commodityInfo[0].dimensions.length = 48;
          deepClone.commodityInfo[0].dimensions.width = 48;
          deepClone.commodityInfo[0].dimensions.height = 52;
        }

        const handleChangeServicesTab = (event, newValue) => {
          setValue(newValue);
        };
        function a11yProps(index) {
          return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`
          };
        }
        function TabPanel(props) {
          const { children, value, index, ...other } = props;

          return (
            <div
              role='tabpanel'
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box sx={{ p: 1 }}>
                  <Typography>{children}</Typography>
                </Box>
              )}
            </div>
          );
        }

        TabPanel.propTypes = {
          children: PropTypes.node,
          index: PropTypes.number.isRequired,
          value: PropTypes.number.isRequired
        };

        return (
          <Grid
            container
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 3,
              maxHeight: {
                xs: '65vh',
                sm: '65vh',
                md: '85vh',
                lg: '85vh',
                xl: '85vh'
              },
              width: '100%',
              overflowY: {
                xs: 'auto',
                sm: 'auto',
                md: 'unset',
                lg: 'unset',
                xl: 'unset'
              }
            }}
          >
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              {isMobile ? (
                <Box sx={{ m: 0.5, width: '90%' }}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='panel1-content'
                      id='panel1-header'
                    >
                      <Typography component='span'>Pickup Services</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: { xs: 'stretch', sm: 'stretch' }, // Full width on mobile
                          width: '100%'
                          // padding: { xs: 1, sm: 2, md: 1 }
                        }}
                      >
                        <Typography
                          className='ServicesTitle m-0'
                          onClick={handlePickupServices}
                          variant='subtitle2'
                        >
                          <FormControl
                            sx={{ m: 0, width: '100%' }}
                            size='large'
                          >
                            {[
                              {
                                label: 'Inside Pickup',
                                state: insidePickupSwitch
                              },
                              {
                                label: 'Lift Gate Services',
                                state: liftgatePickupSwitch
                              },
                              {
                                label: 'Residential Pickup',
                                state: residentialPickupSwitch
                              },
                              {
                                label: 'Secure Access',
                                state: secureAccesPickupSwitch
                              },
                              {
                                label: 'Limited Access',
                                state: limitedPickupAccessSwitch
                              },
                              {
                                label: 'Freeze Protection',
                                state: freezeProtectionPickupSwitch
                              },
                              {
                                label: 'Overlength',
                                state: overlengthPickupSwitch
                              }
                            ].map((service, index) => (
                              <Box
                                key={index}
                                className={classes.switchRoot}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between', // ✅ Puts space between label & switch
                                  width: '100%',
                                  // padding: '8px 0',
                                  flexWrap: 'nowrap', // ✅ Prevents text from wrapping
                                  whiteSpace: 'nowrap' // ✅ Ensures text stays in one line
                                }}
                              >
                                <Typography
                                  className='ServicesSwitcheLabels my-1'
                                  onClick={() =>
                                    handlePickUpServicesChange(service.label)
                                  }
                                  sx={{
                                    fontSize: { xs: '14px', sm: '16px' },
                                    overflow: 'hidden', // ✅ Prevents text overflow
                                    textOverflow: 'ellipsis', // ✅ Adds "..." if text is too long
                                    flexGrow: 1 // ✅ Allows label to take available space
                                  }}
                                >
                                  {service.label}
                                </Typography>
                                <FormControlLabel
                                  sx={{
                                    alignItems: 'flex-end',
                                    marginLeft: 'auto' // ✅ Keeps switch aligned to the right
                                  }}
                                  control={
                                    <Switch
                                      onChange={() =>
                                        handlePickUpServicesChange(
                                          service.label
                                        )
                                      }
                                      size='small'
                                      checked={service.state}
                                      color='primary'
                                      name={service.label}
                                    />
                                  }
                                />
                              </Box>
                            ))}
                          </FormControl>
                          {isOverLength && value === 0 && (
                            <TextField
                              variant='standard'
                              // inputProps={{
                              //   disableUnderline: true
                              // }}
                              fullWidth
                              value={overLengthValue}
                              onChange={e => setOverLengthValue(e.target.value)}
                              size='small'
                              label='Overlength Inches'
                              type='number'
                              // sx={{ width: '90%', margin: '-5 0 0 5' }}
                            />
                          )}
                        </Typography>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion sx={{ mt: 1 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='panel2-content'
                      id='panel2-header'
                    >
                      <Typography component='span'>
                        Delivery Services
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ width: '100%' }}>
                        <Typography
                          className='ServicesTitleDelivery'
                          variant='subtitle2'
                          onClick={() => handleDeliveryServices()}
                        >
                          <FormControl size='large' sx={{ width: '100%' }}>
                            {[
                              {
                                label: 'Inside Delivery',
                                state: insideDeliverySwitch
                              },
                              {
                                label: 'Lift Gate Delivery',
                                state: liftgateDeliverySwitch
                              },
                              {
                                label: 'Residential Delivery',
                                state: residentialDeliverySwitch
                              },
                              {
                                label: 'Secure Access',
                                state: secureAccesDeliverySwitch
                              },
                              {
                                label: 'Limited Access',
                                state: limitedDeliverySwitch
                              },
                              {
                                label: 'Call Before Delivery',
                                state: callBeforeDeliveryServicesSwitch
                              }
                            ].map((service, index) => (
                              <Box
                                key={index}
                                className={classes.switchRoot}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '12vw'
                                  }, // 100% for small screens
                                  whiteSpace: 'nowrap' // Prevent text wrapping
                                }}
                              >
                                <Typography
                                  className='ServicesSwitcheLabels my-1'
                                  onClick={() =>
                                    handleDeliveryServicesChange(service.label)
                                  }
                                  sx={{
                                    textAlign: { xs: 'left', sm: 'left' }, // Align left for all
                                    fontSize: { xs: '14px', sm: '16px' }, // Adjust font size
                                    flexShrink: 1, // Prevent text from squeezing too much
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}
                                >
                                  {service.label}
                                </Typography>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      onChange={() =>
                                        handleDeliveryServicesChange(
                                          service.label
                                        )
                                      }
                                      size='small'
                                      checked={service.state}
                                      color='primary'
                                      name={service.label}
                                    />
                                  }
                                />
                              </Box>
                            ))}
                          </FormControl>
                        </Typography>
                      </Box>
                      <Divider />
                      <>
                        <div
                          // style={{ marginLeft: 10 }}
                          className={classes.switchRoot}
                        >
                          <div>
                            <Typography
                              sx={{ color: 'red' }}
                              className='ServicesSwitcheLabels'
                              onClick={() =>
                                handlePickUpServicesChange('Overlength')
                              }
                            >
                              Hazmat
                            </Typography>
                          </div>
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  sx={
                                    // isMobile
                                    //   ? { color: 'red', mr: 2 }
                                    //   :
                                    { color: 'red' }
                                  }
                                  onChange={() =>
                                    handlePickUpServicesChange('hazmat')
                                  }
                                  size='small'
                                  checked={hazmatSwitch}
                                  color='primary'
                                  name='hazmat'
                                />
                              }
                            />
                          </div>
                        </div>
                        <div style={{ display: '' }}>
                          <div>
                            <TextField
                              fullWidth
                              variant='standard'
                              inputProps={{ disableUnderline: true }}
                              value={CODAmount === 0 ? '' : CODAmount}
                              onChange={e => setCODAmount(e.target.value)}
                              type='number'
                              size='small'
                              label='C.O.D Amounts($)'
                              sx={{ width: '90%', mx: 1 }}
                            />
                          </div>
                          <div>
                            <TextField
                              fullWidth
                              variant='standard'
                              inputProps={{ disableUnderline: true }}
                              value={DeclaredValue === 0 ? '' : DeclaredValue}
                              onChange={e => setDeclaredValue(e.target.value)}
                              type='number'
                              size='small'
                              label=' Declared Value($)'
                              sx={{ width: '90%', mx: 1 }}
                            />
                          </div>
                        </div>
                        <div className='AdditionalFeeTitle'>
                          {/* <Typography className='ServicesSwitcheLabels'>Fee May Apply</Typography> */}
                          <Button
                            size='small'
                            disabled={DisableReloadButton() ? true : false}
                            onClick={() => CallCarrierRatesApi()}
                            sx={{
                              width: '93%',
                              mx: 1,
                              mb: 2,
                              fontSize: '13px',
                              alignSelf: 'center'
                            }}
                            variant='contained'
                          >
                            Reload Price Quote
                          </Button>
                        </div>
                      </>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              ) : (
                <Card
                  className=''
                  sx={{
                    height: {
                      xs: '100%',
                      sm: '100%',
                      md: '69vh',
                      lg: '69vh',
                      xl: '69vh'
                    }
                  }}
                >
                  <CardTitle>
                    <Typography
                      sx={{ padding: 1, m: 0, paddingBottom: 0 }}
                      variant='h5'
                    >
                      Services
                    </Typography>
                    {/* <hr /> */}
                    {/* <AppBar sx={{ backgroundColor: 'white' }} position='static'> */}

                    <Tabs
                      sx={{ overflow: 'hidden' }}
                      variant='fullWidth'
                      aria-label='full width tabs example'
                      value={value}
                      onChange={handleChangeServicesTab}
                    >
                      <Tab
                        style={{
                          textTransform: 'capitalize',
                          alignItems: 'self-start'
                        }}
                        label='Pickup'
                        {...a11yProps(0)}
                      />
                      <Tab
                        style={{
                          textTransform: 'capitalize',
                          alignItems: 'self-start'
                        }}
                        label='Delivery'
                        {...a11yProps(1)}
                      />
                    </Tabs>
                    {/* </AppBar> */}
                  </CardTitle>

                  {!isMobile && (
                    <CardContent
                      className='p-0'
                      sx={{
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        height: {
                          xs: '100%',
                          sm: '100%',
                          md: '100%',
                          lg: '55vh',
                          xl: '55vh'
                        }
                      }}
                    >
                      <TabPanel value={value} index={0}>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: { xs: 'stretch', sm: 'stretch' }, // Full width on mobile
                            width: '100%'
                            // padding: { xs: 1, sm: 2, md: 1 }
                          }}
                        >
                          <Typography
                            className='ServicesTitle m-0'
                            onClick={handlePickupServices}
                            variant='subtitle2'
                          >
                            <FormControl
                              sx={{ m: 0, width: '100%' }}
                              size='large'
                            >
                              {[
                                {
                                  label: 'Inside Pickup',
                                  state: insidePickupSwitch
                                },
                                {
                                  label: 'Lift Gate Services',
                                  state: liftgatePickupSwitch
                                },
                                {
                                  label: 'Residential Pickup',
                                  state: residentialPickupSwitch
                                },
                                {
                                  label: 'Secure Access',
                                  state: secureAccesPickupSwitch
                                },
                                {
                                  label: 'Limited Access',
                                  state: limitedPickupAccessSwitch
                                },
                                {
                                  label: 'Freeze Protection',
                                  state: freezeProtectionPickupSwitch
                                },
                                {
                                  label: 'Overlength',
                                  state: overlengthPickupSwitch
                                }
                              ].map((service, index) => (
                                <Box
                                  key={index}
                                  className={classes.switchRoot}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between', // ✅ Puts space between label & switch
                                    width: '100%',
                                    // padding: '8px 0',
                                    flexWrap: 'nowrap', // ✅ Prevents text from wrapping
                                    whiteSpace: 'nowrap' // ✅ Ensures text stays in one line
                                  }}
                                >
                                  <Typography
                                    className='ServicesSwitcheLabels my-1'
                                    onClick={() =>
                                      handlePickUpServicesChange(service.label)
                                    }
                                    sx={{
                                      fontSize: { xs: '14px', sm: '16px' },
                                      overflow: 'hidden', // ✅ Prevents text overflow
                                      textOverflow: 'ellipsis', // ✅ Adds "..." if text is too long
                                      flexGrow: 1 // ✅ Allows label to take available space
                                    }}
                                  >
                                    {service.label}
                                  </Typography>
                                  <FormControlLabel
                                    sx={{
                                      alignItems: 'flex-end',
                                      marginLeft: 'auto' // ✅ Keeps switch aligned to the right
                                    }}
                                    control={
                                      <Switch
                                        onChange={() =>
                                          handlePickUpServicesChange(
                                            service.label
                                          )
                                        }
                                        size='small'
                                        checked={service.state}
                                        color='primary'
                                        name={service.label}
                                      />
                                    }
                                  />
                                </Box>
                              ))}
                            </FormControl>
                          </Typography>
                        </Box>
                      </TabPanel>

                      {isOverLength && value === 0 && (
                        <TextField
                          variant='standard'
                          // inputProps={{
                          //   disableUnderline: true
                          // }}
                          fullWidth
                          value={overLengthValue}
                          onChange={e => setOverLengthValue(e.target.value)}
                          size='small'
                          label='Overlength Inches'
                          type='number'
                          sx={{ width: '90%', margin: '-5 0 0 5' }}
                        />
                      )}
                      <TabPanel value={value} index={1}>
                        <Box sx={{ width: '100%' }}>
                          <Typography
                            className='ServicesTitleDelivery'
                            variant='subtitle2'
                            onClick={() => handleDeliveryServices()}
                          >
                            <FormControl size='large' sx={{ width: '100%' }}>
                              {[
                                {
                                  label: 'Inside Delivery',
                                  state: insideDeliverySwitch
                                },
                                {
                                  label: 'Lift Gate Delivery',
                                  state: liftgateDeliverySwitch
                                },
                                {
                                  label: 'Residential Delivery',
                                  state: residentialDeliverySwitch
                                },
                                {
                                  label: 'Secure Access',
                                  state: secureAccesDeliverySwitch
                                },
                                {
                                  label: 'Limited Access',
                                  state: limitedDeliverySwitch
                                },
                                {
                                  label: 'Call Before Delivery',
                                  state: callBeforeDeliveryServicesSwitch
                                }
                              ].map((service, index) => (
                                <Box
                                  key={index}
                                  className={classes.switchRoot}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: {
                                      xs: '100%',
                                      sm: '100%',
                                      md: '12vw'
                                    }, // 100% for small screens
                                    whiteSpace: 'nowrap' // Prevent text wrapping
                                  }}
                                >
                                  <Typography
                                    className='ServicesSwitcheLabels my-1'
                                    onClick={() =>
                                      handleDeliveryServicesChange(
                                        service.label
                                      )
                                    }
                                    sx={{
                                      textAlign: { xs: 'left', sm: 'left' }, // Align left for all
                                      fontSize: { xs: '14px', sm: '16px' }, // Adjust font size
                                      flexShrink: 1, // Prevent text from squeezing too much
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}
                                  >
                                    {service.label}
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        onChange={() =>
                                          handleDeliveryServicesChange(
                                            service.label
                                          )
                                        }
                                        size='small'
                                        checked={service.state}
                                        color='primary'
                                        name={service.label}
                                      />
                                    }
                                  />
                                </Box>
                              ))}
                            </FormControl>
                          </Typography>
                        </Box>
                      </TabPanel>

                      <Divider />
                      <>
                        <div
                          style={{ marginLeft: 10 }}
                          className={classes.switchRoot}
                        >
                          <div>
                            <Typography
                              sx={{ color: 'red' }}
                              className='ServicesSwitcheLabels my-1'
                              onClick={() =>
                                handlePickUpServicesChange('Overlength')
                              }
                            >
                              Hazmat
                            </Typography>
                          </div>
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  sx={
                                    isMobile
                                      ? { color: 'red', mr: 2 }
                                      : { color: 'red' }
                                  }
                                  onChange={() =>
                                    handlePickUpServicesChange('hazmat')
                                  }
                                  size='small'
                                  checked={hazmatSwitch}
                                  color='primary'
                                  name='hazmat'
                                />
                              }
                            />
                          </div>
                        </div>
                        <div style={{ display: '' }}>
                          <div>
                            <TextField
                              fullWidth
                              variant='standard'
                              inputProps={{ disableUnderline: true }}
                              value={CODAmount === 0 ? '' : CODAmount}
                              onChange={e => setCODAmount(e.target.value)}
                              type='number'
                              size='small'
                              label='C.O.D Amounts($)'
                              sx={{ width: '90%', mx: 1 }}
                            />
                          </div>
                          <div>
                            <TextField
                              fullWidth
                              variant='standard'
                              inputProps={{ disableUnderline: true }}
                              value={DeclaredValue === 0 ? '' : DeclaredValue}
                              onChange={e => setDeclaredValue(e.target.value)}
                              type='number'
                              size='small'
                              label=' Declared Value($)'
                              sx={{ width: '90%', mx: 1 }}
                            />
                          </div>
                        </div>
                        <div className='AdditionalFeeTitle'>
                          {/* <Typography className='ServicesSwitcheLabels'>Fee May Apply</Typography> */}
                          <Button
                            size='small'
                            disabled={DisableReloadButton() ? true : false}
                            onClick={() => CallCarrierRatesApi()}
                            sx={{
                              width: '93%',
                              mx: 1,
                              mb: 2,
                              fontSize: '13px',
                              alignSelf: 'center'
                            }}
                            variant='contained'
                          >
                            Reload Price Quote
                          </Button>
                        </div>
                      </>
                    </CardContent>
                  )}
                </Card>
              )}
            </Grid>

            <Grid sx={{ mr: -1 }} xs={12} sm={12} md={10} item lg={10} xl={10}>
              <GetShipmentRates
                state={obj}
                deepClone={deepClone}
                totalLBSWeight={
                  quickQuoteFlow
                    ? RatesObj?.commodityInfo?.reduce((total, item) => {
                        return total + parseFloat(item?.weight?.value || 0);
                      }, 0)
                    : RatesObj?.details?.[0]?.grossWeight
                }
                quote={quickQuoteFlow ? 'Quick Quote' : 'quote'}
                DataToShow={PreviousProps}
                ReloadQuote={reloadQuote}
                handleListItemClick={handleListItemClick}
                handleNext={handleNext}
                checkAllCarriersRates={checkAllCarriersRates}
                selectedIndex={selectedIndex}
              />
            </Grid>
          </Grid>
        );
      } else
        return (
          <Box className='ParentFlexDiv' sx={{ mt: 5 }}>
            <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Autocomplete
                fullWidth
                forcePopupIcon={
                  PreviousProps?.shipmentStatus === 'Booked' ? false : true
                }
                sx={{ mt: 2 }}
                disabled={
                  PreviousProps?.shipmentStatus === 'Booked' ? true : false
                }
                size='small'
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    <li {...PreviousProps}>
                      {' '}
                      {
                        <div className='carriers_logo_Parent'>
                          {option.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              style={{ objectFit: 'fill' }}
                              className='carriers_logo'
                              alt={option?.carrierLogo}
                              src={option?.carrierLogo}
                            />
                          )}
                        </div>
                      }{' '}
                      {option.title}
                    </li>
                  </Box>
                )}
                value={
                  PreviousProps?.shipmentStatus === 'Booked'
                    ? PreviousProps?.carrierName
                    : otherCarrierName
                    ? otherCarrierName
                    : carrierName
                }
                onChange={(event, newValue) => {
                  newValue?.title === 'Others' && setOpenOtherCarrier(true);
                  setCarrierName({
                    title: newValue?.title,
                    logo: newValue?.carrierLogo?.logo
                  });
                  setCarrierIdForApi(newValue?.carrierID);
                  newValue?.title !== 'Others' && setOtherCarrierName('');
                  setCarrierName(newValue);
                  setValidationErrors({
                    ...validationErrors,
                    carrierName: null
                  });
                }}
                options={props?.location?.state?.carrierApiNames}
                getOptionLabel={option => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.title;
                }}
                renderInput={params => (
                  <TextField
                    fullWidth
                    {...params}
                    // sx={{ width: '38vw' }}
                    variant='standard'
                    error={Boolean(validationErrors['carrierName'])}
                    helperText={validationErrors['carrierName']}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    label='Carrier Names'
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline:
                        PreviousProps?.shipmentStatus === 'Booked'
                          ? true
                          : false,
                      startAdornment: (carrierName !== null ||
                        otherCarrierName) && (
                        <div
                          style={{ margin: '0 10 0 0' }}
                          className='carriers_logo_Parent'
                        >
                          {otherCarrierName ||
                          carrierName?.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              style={{ objectFit: 'fill' }}
                              className='carriers_logo'
                              alt={carrierName?.carrierLogo}
                              src={carrierName?.carrierLogo}
                            />
                          )}
                        </div>
                      )
                    }}
                  />
                )}
              />
              <TextField
                fullWidth
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                disabled
                sx={{ m: 2 }}
                value={PreviousProps?.totalNetWeight}
                FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                // InputLabelProps={{ style: { fontSize: 13 } }}
                label='Weight(lbs)'
              />
            </div>
            <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Autocomplete
                fullWidth
                disabled
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                className='Margintop'
                // sx={{ width: '38vw' }}
                name='Class'
                size='small'
                options={ClassArray}
                // defaultValue='50'
                value={PreviousProps?.details?.[0]?.freightClass}
                onChange={(event, newValue) =>
                  handleClassInputChange('Class', index, newValue)
                }
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    fullWidth
                    label='Freight Class'
                    variant='standard'
                    sx={{}}
                    // placeholder='Payment Type'

                    {...params}
                    InputProps={{
                      disableUnderline: true
                      // ...params.InputProps
                    }}
                  />
                )}
              />

              <TextField
                fullWidth
                className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ m: 2 }}
                variant='standard'
                disabled={
                  PreviousProps?.carrierApiNames === 'carrierApiNames'
                    ? false
                    : true
                }
                label='NMFC'
                name='NMFCnumber'
                // defaultValue={
                //   PreviousProps?.carrierApiNames === 'carrierApiNames'
                //     ? ''
                //     : '5242141'
                // }
                value={PreviousProps?.details?.[0]?.nmfc}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div>
            <div
              // className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <TextField
                fullWidth
                disabled
                label='Shipment #'
                variant='standard'
                sx={{ mt: 2 }}
                value={PreviousProps?.soNumber}
                // placeholder='Payment Type'

                InputProps={{
                  disableUnderline: true
                  // ...params.InputProps
                }}
              />
              <TextField
                fullWidth
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ mt: 2 }}
                variant='standard'
                disabled
                label='Customer PO#'
                value={PreviousProps?.clientPONumber}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div>
            {props?.location?.state?.disptachOpen === 'Dispatch' && (
              <div
                className='LocationsClass'
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <TextField
                  disabled={assignedProNmb ? true : false}
                  fullWidth
                  error={Boolean(validationErrors['proNumber'])}
                  helperText={validationErrors['proNumber']}
                  className='RightMarginItems'
                  value={proNumber}
                  // onChange={e => setProNumber(e.target.value)}
                  onChange={e => {
                    setProNumber(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      proNumber: null
                    });
                  }}
                  size='small'
                  sx={{ mt: 2 }}
                  variant='standard'
                  label='PRO#'
                  type='text'
                  inputProps={{ disableUnderline: true }}
                />
                <TextField
                  disabled={assignedBolNmb ? true : false}
                  fullWidth
                  className='RightMarginItems'
                  // disabled
                  value={BOLNumber}
                  // value='98642469'
                  label='BOL#'
                  onChange={e => setBOLNumber(e.target.value)}
                  // size='small'
                  // sx={!BOLNumber ? { display: 'none' } : { width: '20vw', mt: 2 }}
                  sx={{ m: 1.7 }}
                  variant='standard'
                  type='text'
                  inputProps={{ disableUnderline: true }}
                />
              </div>
            )}
            <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <TextField
                fullWidth
                className='RightMarginItems'
                variant='standard'
                inputProps={{ disableUnderline: true }}
                // disabled
                value={pickupNumber}
                onChange={e => setPickupNumber(e.target.value)}
                type='text'
                size='small'
                sx={{ mt: 2 }}
                label='Pickup#'
              />
              <TextField
                fullWidth
                error={Boolean(validationErrors['refOrQuoteNmbErr'])}
                helperText={validationErrors['refOrQuoteNmbErr']}
                onChange={e => {
                  setRefOrQuoteNmb(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    refOrQuoteNmbErr: null
                  });
                }}
                className='RightMarginItems'
                value={refOrQuoteNmb}
                size='small'
                sx={{ m: 2 }}
                label='Ref / Quote# If any'
                type='text'
                variant='standard'
                inputProps={{ disableUnderline: true }}
              />
            </div>
          </Box>
        );
    } else if (index === 1) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        return (
          <Box
            className='ParentFlexDiv'
            sx={
              browser === 'Firefox'
                ? { marginTop: 1, marginLeft: '10%' }
                : {
                    marginTop: 0,
                    p: {
                      xs: 2,
                      sm: 2,
                      md: 0,
                      lg: 0,
                      xl: 0
                    },
                    overflowY: {
                      xs: 'scroll',
                      sm: 'scroll',
                      md: 'unset',
                      lg: 'unset',
                      xl: 'unset'
                    },
                    height: {
                      xs: '95%',
                      sm: '95%',
                      md: '95%',
                      lg: '100%',
                      xl: '100%'
                    },
                    marginLeft: { xs: 0, sm: 0, md: 0, lg: '10%', xl: '10%' }
                  }
            }
          >
            <br />
            <Grid container className=''>
              <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                <TextField
                  fullWidth
                  // sx={{ width: '63vw' }}
                  disabled
                  label='Ship From'
                  variant='standard'
                  value={shipFromAddress()}
                />
              </Grid>
            </Grid>

            <Grid container className=''>
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                // error={Boolean(validationErrors['originDate'])}
                // helperText={validationErrors['originDate']}
                onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                // defaultValue={materialDateInput}
                value={PreviousProps?.pickupDate}
                sx={{ width: '43vw', mt: 2 }}
                // type='date'
                label={
                  props?.location?.state?.rateType !== 'Quick Quote' && 'Date'
                }
              />
              <Grid container>
                <Grid
                  item
                  sx={{
                    mt: -7,
                    display: 'flex',
                    justifyContent: {
                      xs: 'flex-start',
                      sm: 'flex-end',
                      md: 'flex-end',
                      lg: 'flex-end',
                      xl: 'flex-end'
                    }
                  }}
                  xs={12}
                  sm={12}
                  md={10}
                  lg={10}
                  xl={10}
                  // className='mt-3 d-flex flex-column'
                  // style={{ width: '20vw' }}
                >
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Grid
                      sx={{
                        fontSize: 13,
                        color: 'rgba(0, 0, 0, 0.58)'
                      }}
                    >
                      Pickup Hours
                    </Grid>
                    <Grid
                      container
                      gap={1}
                      sx={{
                        mt: 1,
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Grid>
                        <TextField
                          label='Open Time'
                          value={originOpenTimeValue}
                          onChange={e => {
                            setOriginOpenTimeValue(e.target.value);
                            setValidationErrors({
                              ...validationErrors,
                              originOpenTime: null
                            });
                          }}
                          type='time'
                          fullWidth
                        />
                      </Grid>
                      <Grid>
                        <TextField
                          label='Close Time'
                          value={originCloseTimeValue}
                          error={Boolean(validationErrors['originCloseTime'])}
                          helperText={validationErrors['originCloseTime']}
                          onChange={e => {
                            setOriginCloseTimeValue(e.target.value);
                            setValidationErrors({
                              ...validationErrors,
                              originCloseTime: null
                            });
                          }}
                          type='time'
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              sx={{
                mt: {
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: -2,
                  xl: -2
                },
                mb: 1
              }}
              container
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={10}
                lg={10}
                xl={10}
                // sx={
                //   browser === 'Firefox'
                //     ? { marginBottom: 30 }
                //     : { marginBottom: 3 }
                // }
              >
                <h6>Pickup Instructions</h6>
                <ReactQuill
                  style={{
                    // width: '63vw',
                    marginTop: 0,
                    height: '8vh'
                  }}
                  value={pickupRemarksHtml}
                  onChange={html => {
                    // Keep full HTML in editor
                    setPickupRemarksHtml(html);

                    // Extract plain text for API or validation
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    const plainText =
                      tempDiv.textContent || tempDiv.innerText || '';
                    setPickupRemarks(plainText);

                    setValidationErrors({
                      ...validationErrors,
                      pickupInstructionsError: null
                    });
                  }}
                />
                <Grid sx={{ mt: '4%' }} className='text-danger'>
                  {validationErrors['pickupInstructionsError']}
                </Grid>
                {/* <div>
              <h2>Preview:</h2>
              <div dangerouslySetInnerHTML={{ __html: pickupInstContent }} />
            </div> */}
              </Grid>
            </Grid>

            <Grid
              container
              sx={{ mt: { xs: 2.5, sm: 2, md: 0, lg: 0, xl: 0 } }}
            >
              <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                <TextField
                  fullWidth
                  sx={{ mt: { xs: 4, sm: 2, md: 2, lg: 2, xl: 2 } }}
                  disabled
                  label='Ship To'
                  variant='standard'
                  value={shipToAddress()}
                />
              </Grid>
            </Grid>
            <Grid container>
              <TextField
                disabled
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                // error={Boolean(validationErrors['originDate'])}
                // helperText={validationErrors['originDate']}
                // onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                // defaultValue={materialDateInput}
                value={PreviousProps?.deliveryDate}
                sx={{ width: '43vw', mt: 2 }}
                // type='date'
                label={
                  props?.location?.state?.rateType !== 'Quick Quote' &&
                  'Est Delivery Date'
                }
              />
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={10}
                  lg={10}
                  xl={10}
                  sx={{
                    mt: -7,
                    display: 'flex',
                    justifyContent: {
                      xs: 'flex-start',
                      sm: 'flex-end',
                      md: 'flex-end',
                      lg: 'flex-end',
                      xl: 'flex-end'
                    }
                  }}
                >
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Grid
                      sx={{
                        fontSize: 13,
                        color: 'rgba(0, 0, 0, 0.58)'
                      }}
                    >
                      Delivery Hours
                    </Grid>
                    <Grid sx={{ display: 'flex', mt: 1 }}>
                      <Grid container gap={1}>
                        <Grid>
                          <TextField
                            label='Open Time'
                            value={destinationOpenTimeValue}
                            onChange={e => {
                              setDestinationOpenTimeValue(e.target.value);
                              setValidationErrors({
                                ...validationErrors,
                                originOpenTime: null
                              });
                            }}
                            type='time'
                            fullWidth
                          />
                        </Grid>

                        <Grid>
                          <TextField
                            label='Close Time'
                            error={Boolean(
                              validationErrors['destinationCloseTime']
                            )}
                            helperText={
                              validationErrors['destinationCloseTime']
                            }
                            value={destinationCloseTimeValue}
                            onChange={e => {
                              setDestinationCloseTimeValue(e.target.value);
                              setValidationErrors({
                                ...validationErrors,
                                destinationCloseTime: null
                              });
                            }}
                            type='time'
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              sx={{
                mt: {
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: -2,
                  xl: -2
                },
                mb: 8
              }}
            >
              <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                <h6>Delivery Instructions</h6>
                <ReactQuill
                  style={{
                    height: '8vh',
                    marginTop: 0
                  }}
                  value={deliveryRemarksHtml}
                  // onChange={e => {
                  //   setDeliveryRemarks(e);
                  //   setValidationErrors({
                  //     ...validationErrors,
                  //     deliveryInstructionsError: null
                  //   });
                  // }}
                  onChange={html => {
                    // Keep full HTML in editor
                    setDeliveryRemarksHtml(html);

                    // Extract plain text for API or validation
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    const plainText =
                      tempDiv.textContent || tempDiv.innerText || '';
                    setDeliveryRemarks(plainText);

                    setValidationErrors({
                      ...validationErrors,
                      deliveryInstructionsError: null
                    });
                  }}
                />

                <Grid sx={{ mt: '4%' }} className='text-danger'>
                  {validationErrors['deliveryInstructionsError']}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        );
      }
      return (
        <Box
          sx={{
            marginTop: 0,
            height: '60vh',
            overflowY: 'scroll',
            overflowX: 'hidden'
          }}
        >
          <Box sx={{ marginTop: 5 }}>
            <div className='OriginTitle'>Origin</div>
            <hr />

            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw' }}
                  disabled
                  label='Contact Person'
                  variant='standard'
                  value={PreviousProps?.originContactPerson}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw' }}
                  disabled
                  label='Company'
                  variant='standard'
                  value={PreviousProps?.originCompany}
                />
              </div>
            </div>

            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Address'
                  variant='standard'
                  value={PreviousProps?.originAddress}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  disabled
                  sx={{ width: '20vw', mt: 2 }}
                  label='City/State/Zip/Country'
                  value={
                    PreviousProps?.originCity +
                    ' ' +
                    PreviousProps?.originState +
                    ' ' +
                    PreviousProps?.originZipCode
                  }
                />
              </div>
            </div>
            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Phone'
                  variant='standard'
                  value={PreviousProps?.originContactPhone}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Email'
                  variant='standard'
                  value={PreviousProps?.originContactEmail}
                />
              </div>
            </div>

            <div style={{ display: 'LocationsClass' }}>
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                error={Boolean(validationErrors['originDate'])}
                helperText={validationErrors['originDate']}
                onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                value={PreviousProps?.pickupDate}
                // defaultValue={materialDateInput}
                sx={{ width: '19vw', mt: 2 }}
                // type='date'
                label='Pickup Date'
              />
            </div>

            <Typography variant='h5' className='DestinationTitle'>
              Destination
            </Typography>
            <hr />
            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw' }}
                  disabled
                  label='Contact Person'
                  variant='standard'
                  // defaultValue='Robert Thomas'
                  value={PreviousProps?.destinationContactPerson}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw' }}
                  disabled
                  label='Company'
                  variant='standard'
                  value={PreviousProps?.destinationCompany}
                />
              </div>
            </div>

            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Address'
                  variant='standard'
                  value={PreviousProps?.destinationAddress}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  disabled
                  sx={{ width: '20vw', mt: 2 }}
                  label='City/State/Zip/Country'
                  value={
                    PreviousProps?.destinationCity +
                    ' ' +
                    PreviousProps?.destinationState +
                    ' ' +
                    PreviousProps?.destinationZipCode
                  }
                />
              </div>
            </div>
            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Phone'
                  variant='standard'
                  value={PreviousProps?.destinationContactPhone}
                  InputProps={{
                    disableUnderline: true
                  }}
                />
              </div>
              <div>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw', mt: 2 }}
                  disabled
                  label='Email'
                  variant='standard'
                  value={PreviousProps?.destinationContactEmail}
                />
              </div>
            </div>

            <div style={{ display: 'LocationsClass' }}>
              <TextField
                disabled
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                error={Boolean(validationErrors['originDate'])}
                helperText={validationErrors['originDate']}
                onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                value={PreviousProps?.deliveryDate}
                sx={{ width: '19vw', mt: 2 }}
                // type='date'
                label='Exp Delivery Date'
              />
            </div>
          </Box>
          {/* Dispatch Preview  */}
          <div className='OriginTitle'>Shipment Information</div>
          <hr />
          <Box sx={{ mt: 5 }}>
            {/* <Typography sx={{ mb: 1 }} variant='body2'> */}
            <div className='LocationsClass'>
              <Autocomplete
                disabled
                sx={{ width: '20vw' }}
                // disabled={
                //   PreviousProps?.carrierApiNames === 'carrierApiNames' ? true : false
                // }
                size='small'
                value={
                  carrierName
                    ? carrierName
                    : otherCarrierName
                    ? otherCarrierName
                    : PreviousProps?.carrierName
                }
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    <li {...PreviousProps}>{option.title}</li>
                  </Box>
                )}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setCarrierName({
                      title: newValue.title
                    });
                    setSelectedCarrierID({
                      ID: newValue.carrierID
                    });
                    setValidationErrors({
                      ...validationErrors,
                      carrierName: null
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setCarrierName({
                      title: newValue.inputValue
                    });
                    setValidationErrors({
                      ...validationErrors,
                      carrierName: null
                    });
                  } else {
                    setCarrierName(newValue);
                    setValidationErrors({
                      ...validationErrors,
                      carrierName: null
                    });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    option => inputValue === option.title
                  );
                  if (inputValue !== '' && !isExisting) {
                    filtered.push({
                      inputValue,
                      title: `Add New Carrier "${inputValue}"`
                    });
                  }

                  return filtered;
                }}
                options={PreviousProps?.carrierApiNames}
                getOptionLabel={option => {
                  if (typeof option === 'string') {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.title;
                }}
                freeSolo
                renderInput={params => (
                  <TextField
                    disabled
                    sx={{ width: '20vw' }}
                    variant='standard'
                    error={Boolean(validationErrors['carrierName'])}
                    helperText={validationErrors['carrierName']}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    {...params}
                    InputProps={{
                      disableUnderline: true,
                      ...params.InputProps
                    }}
                    label='Carrier Name'
                  />
                )}
              />

              <TextField
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                disabled
                sx={{ width: '20vw', mt: 0 }}
                value={PreviousProps?.totalNetWeight}
                error={Boolean(validationErrors['carrierName'])}
                helperText={validationErrors['carrierName']}
                FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                // InputLabelProps={{ style: { fontSize: 13 } }}
                label='Weight(lbs)'
              />
            </div>
            <div className='LocationsClass'>
              <Autocomplete
                disabled
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                // className='Margintop'
                sx={{ width: '20vw', mt: 2 }}
                name='Class'
                size='small'
                options={ClassArray}
                // defaultValue='50'
                value={PreviousProps?.details?.[0]?.freightClass}
                onChange={(event, newValue) =>
                  handleClassInputChange('Class', index, newValue)
                }
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    label='Freight Class'
                    variant='standard'
                    sx={{ width: '20vw' }}
                    // placeholder='Payment Type'

                    {...params}
                    InputProps={{
                      disableUnderline: true
                      // ...params.InputProps
                    }}
                  />
                )}
              />

              <TextField
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ width: '20vw', mt: 2 }}
                variant='standard'
                disabled
                label='NMFC'
                name='NMFCnumber'
                // defaultValue='5242141'
                value={PreviousProps?.details?.[0]?.nmfc}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div>
            <div style={{ marginTop: 10 }} className='LocationsClass'>
              <TextField
                disabled
                label='Shipment #'
                value={PreviousProps?.soNumber}
                variant='standard'
                sx={{ width: '20vw', mt: 0 }}
                // placeholder='Payment Type'

                InputProps={{
                  disableUnderline: true
                  // ...params.InputProps
                }}
              />

              <TextField
                className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ width: '20vw', ml: 0 }}
                variant='standard'
                disabled
                label='Customer PO#'
                value={PreviousProps?.clientPONumber}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div>
            <div style={{ marginTop: 10 }} className='LocationsClass'>
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                className='Margintop'
                value={proNumber}
                // onChange={e => setProNumber(e.target.value)}
                size='small'
                sx={!proNumber ? { display: 'none' } : { width: '20vw', mt: 0 }}
                variant='standard'
                label='PRO#'
                type='text'
                inputProps={{ disableUnderline: true }}
              />
              {refOrQuoteNmb && (
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  disabled
                  className='RightMarginItems'
                  value={refOrQuoteNmb}
                  onChange={e => setRefOrQuoteNmb(e.target.value)}
                  size='small'
                  sx={
                    !proNumber
                      ? { width: '20vw', ml: 0 }
                      : { width: '20vw', ml: 0 }
                  }
                  label='Ref / Quote# If any'
                  type='text'
                  variant='standard'
                  inputProps={{ disableUnderline: true }}
                />
              )}
            </div>
            <div className='LocationsClass'>
              <TextField
                className='Margintop'
                disabled
                value={BOLNumber}
                // value='98642469'
                onChange={e => setBOLNumber(e.target.value)}
                type='text'
                size='small'
                sx={!BOLNumber ? { display: 'none' } : { width: '20vw', mt: 2 }}
                label='BOL#'
                variant='standard'
                InputProps={{
                  disableUnderline: true
                }}
              />
              {pickupNumber && (
                <TextField
                  className='RightMarginItems'
                  variant='standard'
                  InputProps={{
                    disableUnderline: true
                  }}
                  disabled
                  value={pickupNumber}
                  onChange={e => setPoRefNumber(e.target.value)}
                  type='text'
                  size='small'
                  sx={
                    !BOLNumber
                      ? { width: '20vw', margin: '1 0 0 0' }
                      : { width: '20vw', mt: 2 }
                  }
                  label='Pickup#'
                />
              )}
            </div>
            <div className='LocationsClass'>
              <Autocomplete
                freeSolo
                disabled
                className='Margintop'
                sx={{ width: '20vw', margin: '15 0 0 0' }}
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                size='small'
                options={PaymentTypeArr}
                value={paymentTypeValue()}
                onChange={(event, newValue) => {
                  setPaymentType(newValue);
                  setValidationErrors({
                    ...validationErrors,
                    paymentTerms: null
                  });
                }}
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    disabled
                    variant='standard'
                    FormHelperTextProps={{ style: { margin: '5 30 0 0' } }}
                    error={Boolean(validationErrors['paymentTerms'])}
                    helperText={validationErrors['paymentTerms']}
                    label='Freight Payment Type'
                    {...params}
                    InputProps={{
                      disableUnderline: true,
                      ...params.InputProps
                    }}
                  />
                )}
              />
              {/* <Autocomplete
                freeSolo
                disabled
                sx={{ width: '20vw' }}
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                size='small'
                // options={HazmatOptions}
                value={hazmatSwitch ? 'Yes' : 'No'}
                onChange={(event, newValue) => {
                  setHazmatType(newValue);
                  setValidationErrors({
                    ...validationErrors,
                    paymentTerms: null
                  });
                }}
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    className='RightMarginItems'
                    variant='standard'
                    inputProps={{ disableUnderline: true }}
                    FormHelperTextProps={{ style: { margin: '5 30 0 0' } }}
                    error={Boolean(validationErrors['paymentTerms'])}
                    helperText={validationErrors['paymentTerms']}
                    label='Hazmat'
                    {...params}
                    InputProps={{
                      disableUnderline: true,
                      ...params.InputProps
                    }}
                  />
                )}
              /> */}
            </div>
          </Box>
          <br />
          {(insidePickupSwitch ||
            liftgatePickupSwitch ||
            residentialPickupSwitch ||
            secureAccesPickupSwitch ||
            limitedPickupAccessSwitch ||
            freezeProtectionPickupSwitch ||
            insideDeliverySwitch ||
            liftgateDeliverySwitch ||
            residentialDeliverySwitch ||
            secureAccesDeliverySwitch ||
            limitedDeliverySwitch ||
            callBeforeDeliveryServicesSwitch) && (
            <>
              <div className='OriginTitle'>Services Optional</div>
              <hr />
              <Box sx={{}}>
                <div style={{ display: 'flex' }}>
                  <div>
                    <Typography className='ServicesTitle' variant='subtitle2'>
                      Pickup
                    </Typography>
                  </div>

                  <div>
                    <Typography
                      className='ServicesTitleDelivery'
                      variant='subtitle2'
                    >
                      Delivery
                    </Typography>
                  </div>
                </div>
                <div className='PreviewServicesSwitches'>
                  <div>
                    <FormControl sx={{ m: 0 }} size='large'>
                      {insidePickupSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='TopPreviewSwitcheLabels'>
                            Inside Pickup
                          </Typography>
                        </div>
                      )}
                      {liftgatePickupSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Lift Gate Services
                          </Typography>
                        </div>
                      )}
                      {residentialPickupSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Residential Pickup
                          </Typography>
                        </div>
                      )}
                      {secureAccesPickupSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Secure Access
                          </Typography>
                        </div>
                      )}
                      {limitedPickupAccessSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Limited Access
                          </Typography>
                        </div>
                      )}
                      {freezeProtectionPickupSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Freeze Protection
                          </Typography>
                        </div>
                      )}
                    </FormControl>
                  </div>
                  <div>
                    <FormControl size='large'>
                      {insideDeliverySwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='TopPreviewSwitcheLabels'>
                            Inside Delivery
                          </Typography>
                        </div>
                      )}
                      {liftgateDeliverySwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Lift Gate Services
                          </Typography>
                        </div>
                      )}
                      {residentialDeliverySwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Residential Delivery
                          </Typography>
                        </div>
                      )}

                      {secureAccesDeliverySwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Secure Access
                          </Typography>
                        </div>
                      )}
                      {limitedDeliverySwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Limited Access
                          </Typography>
                        </div>
                      )}

                      {callBeforeDeliveryServicesSwitch && (
                        <div className={classes.switchRoot}>
                          <Typography className='PreviewSwitcheLabels'>
                            Call Before Delivery
                          </Typography>
                        </div>
                      )}
                    </FormControl>
                  </div>
                </div>
              </Box>
            </>
          )}
          <br />
          {otherCarrierName && (
            <div className='OriginTitle'>Other Carrier Info</div>
          )}
          <hr />

          {otherCarrierName && (
            <Box className='RemarksParent'>
              <TextField
                variant='standard'
                InputProps={{ disableUnderline: true }}
                disabled
                error={Boolean(validationErrors['otherCarrierName'])}
                helperText={validationErrors['otherCarrierName']}
                value={otherCarrierName}
                onChange={e => {
                  setOtherCarrierName(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    otherCarrierName: null
                  });
                }}
                sx={{ width: '20vw' }}
                size='small'
                label='Carrier Name'
              />
              <TextField
                variant='standard'
                InputProps={{ disableUnderline: true }}
                disabled
                error={Boolean(validationErrors['truckNumber'])}
                helperText={validationErrors['truckNumber']}
                value={truckNumber}
                onChange={e => {
                  setTruckNumber(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    truckNumber: null
                  });
                }}
                sx={{ width: '20vw' }}
                size='small'
                label='Truck Number'
              />
              <TextField
                variant='standard'
                InputProps={{ disableUnderline: true }}
                disabled
                error={Boolean(validationErrors['driverName'])}
                helperText={validationErrors['driverName']}
                value={driverName}
                onChange={e => {
                  setDriverName(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    driverName: null
                  });
                }}
                sx={{ width: '20vw', mt: 0 }}
                size='small'
                label='Driver Name'
              />
              <TextField
                variant='standard'
                InputProps={{ disableUnderline: true }}
                disabled
                error={Boolean(validationErrors['driverNumber'])}
                helperText={validationErrors['driverNumber']}
                value={driverNumber}
                onPaste={handlePhoneNumberPaste}
                onChange={e => {
                  setDriverNumber(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    driverNumber: null
                  });
                }}
                sx={{ width: '20vw', mt: 0 }}
                size='small'
                label='Driver Number'
              />
            </Box>
          )}
        </Box>
      );
    } else if (index === 2) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        return (
          <Box
            sx={{
              marginTop: 0,
              height: '70vh',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}
          >
            <Box sx={{ marginTop: 2 }}>
              <div className='OriginTitle'>Origin</div>
              <hr />

              <Grid gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    inputRef={enterOriginName}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    error={Boolean(validationErrors['originNameError'])}
                    helperText={validationErrors['originNameError']}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    disabled={quickQuoteFlow ? false : true}
                    // sx={{ width: '19vw' }}
                    fullWidth
                    label='Contact Person'
                    variant='standard'
                    value={
                      quickQuoteFlow
                        ? originName
                        : PreviousProps?.originContactPerson
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        originNameError: null
                      });
                      setOriginName(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    error={Boolean(validationErrors['originCompanyNameError'])}
                    helperText={validationErrors['originCompanyNameError']}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    inputRef={enterOriginCompany}
                    // sx={
                    //   quickQuoteFlow
                    //     ? { width: '19vw', ml: 2 }
                    //     : { width: '20vw' }
                    // }
                    fullWidth
                    disabled={quickQuoteFlow ? false : true}
                    label='Company'
                    variant='standard'
                    value={
                      quickQuoteFlow
                        ? originCompanyName
                        : PreviousProps?.originCompany
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        originCompanyNameError: null
                      });

                      setOriginCompanyName(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid sx={{ mt: 2 }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    inputRef={enterOriginStreet}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    error={Boolean(validationErrors['originStreetError'])}
                    helperText={validationErrors['originStreetError']}
                    // sx={
                    //   quickQuoteFlow
                    //     ? { width: '19vw', mt: 1 }
                    //     : { width: '19vw' }
                    // }
                    fullWidth
                    disabled={quickQuoteFlow ? false : true}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    label='Street Address'
                    variant='standard'
                    value={
                      quickQuoteFlow
                        ? originAddress
                        : PreviousProps?.originContactPerson
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        originStreetError: null
                      });
                      setOriginAddress(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    InputProps={{
                      disableUnderline: false
                    }}
                    variant='standard'
                    disabled
                    fullWidth
                    // sx={{ width: '20vw', mt: 2, ml: 2 }}
                    label='City/State/Zip/Country'
                    value={shipFromAddress()}
                  />
                </Grid>
              </Grid>
              {quickQuoteFlow && (
                <Grid sx={{ mt: 2 }} gap={2} container>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: quickQuoteFlow ? false : true
                      }}
                      fullWidth
                      // sx={
                      //   quickQuoteFlow
                      //     ? { width: '19vw', mt: 1.4, mr: 2 }
                      //     : { width: '20vw' }
                      // }
                      disabled={quickQuoteFlow ? false : true}
                      inputRef={enterOriginPhone}
                      label='Phone'
                      variant='standard'
                      FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                      error={Boolean(validationErrors['phoneNumberError'])}
                      helperText={validationErrors['phoneNumberError']}
                      onChange={event =>
                        handleCarrierPhoneNumberChange(event, 'origin')
                      }
                      onPaste={event =>
                        handleCarrierPhoneNumberPaste(event, 'originPhone')
                      }
                      value={phoneNumber}
                      required
                      size='small'
                      type='text'
                      inputProps={{
                        maxLength: 10
                      }}
                    />
                  </Grid>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      error={Boolean(validationErrors['originEmailError'])}
                      helperText={validationErrors['originEmailError']}
                      inputRef={enterOriginEmail}
                      InputProps={{
                        disableUnderline: quickQuoteFlow ? false : true
                      }}
                      fullWidth
                      // sx={
                      //   quickQuoteFlow
                      //     ? { width: '19vw', mt: 1 }
                      //     : { width: '20vw' }
                      // }
                      disabled={quickQuoteFlow ? false : true}
                      label='Email'
                      type='email'
                      variant='standard'
                      value={originEmail}
                      onChange={e => {
                        setValidationErrors({
                          ...validationErrors,
                          originEmailError: null
                        });
                        setOriginEmail(e.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              )}
              {props?.location?.state?.rateType !== 'Quick Quote' && (
                <Grid sx={{ mt: 2 }} gap={2} container>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      fullWidth
                      // sx={{ width: '20vw', mt: 2 }}
                      disabled
                      label='Phone'
                      variant='standard'
                      value={PreviousProps?.originContactPhone}
                      InputProps={{
                        disableUnderline: true
                      }}
                    />
                  </Grid>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: true
                      }}
                      fullWidth
                      // sx={{ width: '20vw', mt: 2 }}
                      disabled
                      label='Email'
                      variant='standard'
                      value={PreviousProps?.originContactEmail}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    disabled={quickQuoteFlow ? false : true}
                    variant='standard'
                    error={Boolean(validationErrors['PickupDate'])}
                    helperText={validationErrors['PickupDate']}
                    onChange={e => handleDateChange(e)}
                    size='small'
                    value={
                      quickQuoteFlow ? originDate : PreviousProps?.pickupDate
                    }
                    defaultValue={
                      quickQuoteFlow
                        ? materialDateInput
                        : PreviousProps?.pickupDate
                    }
                    fullWidth
                    // sx={{ width: '19vw', mt: 2 }}
                    type={quickQuoteFlow ? 'date' : 'text'}
                    label='Pickup Date'
                    onClick={e =>
                      setValidationErrors({
                        ...validationErrors,
                        originDate: ''
                      })
                    }
                  />
                </Grid>
                <Grid
                  sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}
                  item
                  xs={11}
                  sm={10}
                  md={4}
                  lg={4}
                  xl={3}
                >
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    disabled
                    variant='standard'
                    FormHelperTextProps={{
                      style: { whiteSpace: 'nowrap' }
                    }}
                    error={Boolean(validationErrors['originOpenTime'])}
                    helperText={validationErrors['originOpenTime']}
                    id='time'
                    onChange={e => {
                      handleTimeChange(e, 'OriginOpenTime');
                      setValidationErrors({
                        ...validationErrors,
                        originOpenTime: null
                      });
                    }}
                    value={originOpenTimeValue}
                    size='small'
                    fullWidth
                    // sx={{ width: '10vw', m: 2 }}
                    type='time'
                    label='Open Time'
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    disabled
                    variant='standard'
                    FormHelperTextProps={{
                      style: { whiteSpace: 'nowrap' }
                    }}
                    error={Boolean(validationErrors['originCloseTime'])}
                    helperText={validationErrors['originCloseTime']}
                    id='time'
                    value={originCloseTimeValue}
                    onChange={e => {
                      handleTimeChange(e, 'OriginCloseTime');
                      setValidationErrors({
                        ...validationErrors,
                        originCloseTime: null
                      });
                    }}
                    size='small'
                    fullWidth
                    // sx={{ width: '10vw', margin: '15 0 0 0' }}
                    type='time'
                    label='Close Time'
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
              </Grid>

              <Typography variant='h5' className='DestinationTitle'>
                Destination
              </Typography>
              <hr />
              <Grid sx={{ mt: 2 }} gap={2} container>
                {quickQuoteFlow ? (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      inputRef={enterDestinationName}
                      FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                      error={Boolean(validationErrors['destinationNameError'])}
                      helperText={validationErrors['destinationNameError']}
                      // sx={{ width: '19vw' }}
                      fullWidth
                      label='Contact Person'
                      variant='standard'
                      value={
                        quickQuoteFlow
                          ? destinationName
                          : PreviousProps?.originContactPerson
                      }
                      onChange={e => {
                        setValidationErrors({
                          ...validationErrors,
                          destinationNameError: null
                        });
                        setDestinationName(e.target.value);
                      }}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      fullWidth
                      // sx={
                      //   quickQuoteFlow ? { width: '19vw' } : { width: '20vw' }
                      // }
                      disabled={quickQuoteFlow ? false : true}
                      InputProps={{
                        disableUnderline: quickQuoteFlow ? false : true
                      }}
                      label='Company'
                      variant='standard'
                      // defaultValue='Robert Thomas'
                      value={
                        quickQuoteFlow
                          ? destinationAddress
                          : PreviousProps?.destinationContactPerson
                      }
                      onChange={e => setDestinationAddress(e.target.value)}
                    />
                  </Grid>
                )}
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    error={Boolean(
                      validationErrors['destinationCompanyNameError']
                    )}
                    helperText={validationErrors['destinationCompanyNameError']}
                    fullWidth
                    // sx={
                    //   quickQuoteFlow
                    //     ? { width: '19vw', ml: 2 }
                    //     : { width: '20vw' }
                    // }
                    disabled={quickQuoteFlow ? false : true}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    inputRef={enterDestinationCompany}
                    label='Company'
                    variant='standard'
                    value={
                      quickQuoteFlow
                        ? destinationCompanyName
                        : PreviousProps?.destinationCompany
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        destinationCompanyNameError: null
                      });
                      setDestinationCompanyName(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid sx={{ mt: 2 }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    error={Boolean(validationErrors['destinationAddressError'])}
                    helperText={validationErrors['destinationAddressError']}
                    inputRef={enterDestinationSteet}
                    fullWidth
                    // sx={
                    //   quickQuoteFlow
                    //     ? { width: '19vw', mt: 1, mr: 2 }
                    //     : { width: '20vw' }
                    // }
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    disabled={quickQuoteFlow ? false : true}
                    label='Street Address'
                    variant='standard'
                    value={
                      quickQuoteFlow
                        ? destinationAddress
                        : PreviousProps?.destinationContactPerson
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        destinationAddressError: null
                      });
                      setDestinationAddress(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    InputProps={{
                      disableUnderline: false
                    }}
                    variant='standard'
                    disabled
                    fullWidth
                    // sx={{ width: '20vw', mt: 2 }}
                    label='City/State/Zip/Country'
                    value={shipToAddress()}
                  />
                </Grid>
              </Grid>
              {quickQuoteFlow && (
                <Grid sx={{ mt: 2 }} gap={2} container>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: quickQuoteFlow ? false : true
                      }}
                      fullWidth
                      // sx={
                      //   quickQuoteFlow
                      //     ? { width: '19vw', mt: 1.4, mr: 2 }
                      //     : { width: '20vw' }
                      // }
                      disabled={quickQuoteFlow ? false : true}
                      inputRef={enterDestinationPhone}
                      label='Phone'
                      variant='standard'
                      FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                      error={Boolean(
                        validationErrors['destinationPhoneNumberError']
                      )}
                      helperText={
                        validationErrors['destinationPhoneNumberError']
                      }
                      onChange={event =>
                        handleCarrierPhoneNumberChange(event, 'destination')
                      }
                      value={destinationPhoneNumber}
                      onPaste={event =>
                        handleCarrierPhoneNumberPaste(event, 'destinationPhone')
                      }
                      required
                      // InputLabelProps={{ style: { fontSize: 13 } }}
                      size='small'
                      type='text'
                      inputProps={{
                        maxLength: 10
                      }}
                    />
                  </Grid>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      error={Boolean(validationErrors['destinationEmailError'])}
                      helperText={validationErrors['destinationEmailError']}
                      inputRef={enterDestinationEmail}
                      InputProps={{
                        disableUnderline: quickQuoteFlow ? false : true
                      }}
                      fullWidth
                      // sx={
                      //   quickQuoteFlow
                      //     ? { width: '19vw', mt: 1 }
                      //     : { width: '20vw' }
                      // }
                      disabled={quickQuoteFlow ? false : true}
                      label='Email'
                      type='email'
                      variant='standard'
                      value={destinationEmail}
                      onChange={e => {
                        setValidationErrors({
                          ...validationErrors,
                          destinationEmailError: null
                        });
                        setDestinationEmail(e.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              )}
              {props?.location?.state?.rateType !== 'Quick Quote' && (
                <Grid sx={{ mt: 2 }} gap={2} container>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      fullWidth
                      // sx={{ width: '20vw', mt: 2 }}
                      disabled
                      label='Phone'
                      variant='standard'
                      value={PreviousProps?.destinationContactPhone}
                      InputProps={{
                        disableUnderline: true
                      }}
                    />
                  </Grid>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: true
                      }}
                      fullWidth
                      // sx={{ width: '20vw', mt: 2 }}
                      disabled
                      label='Email'
                      variant='standard'
                      value={PreviousProps?.destinationContactEmail}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    disabled
                    InputProps={{
                      disableUnderline: false
                    }}
                    variant='standard'
                    // error={Boolean(validationErrors['originDate'])}
                    // helperText={validationErrors['originDate']}
                    onChange={e => setOriginDate(new Date(e.target.value))}
                    size='small'
                    value={
                      quickQuoteFlow
                        ? apiDisplayDate
                          ? apiDisplayDate
                          : 'N/A'
                        : PreviousProps?.deliveryDate
                    }
                    fullWidth
                    // sx={{ width: '19vw', mt: 2 }}
                    // type='date'
                    label='Est Delivery Date'
                  />
                </Grid>
                <Grid
                  sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}
                  item
                  xs={11}
                  sm={10}
                  md={4}
                  lg={4}
                  xl={3}
                >
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    disabled
                    variant='standard'
                    FormHelperTextProps={{
                      style: { whiteSpace: 'nowrap' }
                    }}
                    error={Boolean(validationErrors['originOpenTime'])}
                    helperText={validationErrors['originOpenTime']}
                    id='time'
                    onChange={e => {
                      handleTimeChange(e, 'OriginOpenTime');
                      setValidationErrors({
                        ...validationErrors,
                        originOpenTime: null
                      });
                    }}
                    value={destinationOpenTimeValue}
                    size='small'
                    fullWidth
                    // sx={{ width: '10vw', m: 2 }}
                    type='time'
                    label='Open Time'
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    fullWidth
                    disabled
                    variant='standard'
                    FormHelperTextProps={{
                      style: { whiteSpace: 'nowrap' }
                    }}
                    error={Boolean(validationErrors['originCloseTime'])}
                    helperText={validationErrors['originCloseTime']}
                    id='time'
                    value={destinationCloseTimeValue}
                    onChange={e => {
                      handleTimeChange(e, 'OriginCloseTime');
                      setValidationErrors({
                        ...validationErrors,
                        originCloseTime: null
                      });
                    }}
                    size='small'
                    // sx={{ width: '10vw', margin: '15 0 0 0' }}
                    type='time'
                    label='Close Time'
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            {/* get Rates Preview */}
            <div className='OriginTitle'>Shipment Information</div>
            <hr />
            <Box sx={{ mt: 1 }}>
              <Grid sx={{ mt: 0, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    fullWidth
                    // className='RightMarginItems'
                    // sx={{ width: '40vw', mb: 2 }}
                    variant='standard'
                    label='Item description'
                    name='Item description'
                    value={itemDescription}
                    multiline
                    onChange={e => {
                      const inputValue = e.target.value;
                      if (inputValue.length <= 255) {
                        setItemDescription(inputValue);
                      }
                    }}
                    size='small'
                  />
                </Grid>
              </Grid>
              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <Autocomplete
                    disabled
                    fullWidth
                    // sx={{ width: '20vw' }}
                    size='small'
                    value={
                      props?.location?.state?.disptachOpen === 'Get Quote'
                        ? selectedCarrierNameQuoteRates
                        : PreviousProps?.selectedCarrier
                        ? PreviousProps?.selectedCarrier?.carrierName
                        : carrierName
                    }
                    renderOption={(PreviousProps, option) => (
                      <Box style={{ fontSize: 13 }} {...PreviousProps}>
                        <li {...PreviousProps}>{option.title}</li>
                      </Box>
                    )}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setCarrierName({
                          title: newValue.title
                        });
                        setSelectedCarrierID({
                          ID: newValue.carrierID
                        });
                        setValidationErrors({
                          ...validationErrors,
                          carrierName: null
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setCarrierName({
                          title: newValue.inputValue
                        });
                        setValidationErrors({
                          ...validationErrors,
                          carrierName: null
                        });
                      } else {
                        setCarrierName(newValue);
                        setValidationErrors({
                          ...validationErrors,
                          carrierName: null
                        });
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        option => inputValue === option.title
                      );
                      if (inputValue !== '' && !isExisting) {
                        filtered.push({
                          inputValue,
                          title: `Add New Carrier "${inputValue}"`
                        });
                      }

                      return filtered;
                    }}
                    options={PreviousProps?.carrierApiNames}
                    getOptionLabel={option => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    // renderOption={(PreviousProps, option) => <li {...PreviousProps}>{option.title}</li>}

                    freeSolo
                    renderInput={params => (
                      <TextField
                        disabled
                        fullWidth
                        // sx={{ width: '20vw' }}
                        variant='standard'
                        error={Boolean(validationErrors['carrierName'])}
                        helperText={validationErrors['carrierName']}
                        FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                        {...params}
                        InputProps={{
                          disableUnderline: false,
                          ...params.InputProps
                        }}
                        label='Carrier Name'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    // className='RightMarginItems'
                    InputProps={{
                      disableUnderline: false
                    }}
                    variant='standard'
                    disabled
                    fullWidth
                    // sx={{ width: '20vw' }}
                    value={
                      quickQuoteFlow
                        ? PreviousProps?.commodityInfo?.reduce(
                            (total, item) => {
                              return (
                                total + parseFloat(item?.weight?.value || 0)
                              );
                            },
                            0
                          )
                        : PreviousProps?.totalNetWeight
                    }
                    error={Boolean(validationErrors['carrierName'])}
                    helperText={validationErrors['carrierName']}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    // InputLabelProps={{ style: { fontSize: 13 } }}
                    label='Weight(lbs)'
                  />
                </Grid>
              </Grid>
              {carrierShipType === 'LTL' && (
                <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <Autocomplete
                      disabled
                      renderOption={(PreviousProps, option) => (
                        <Box style={{ fontSize: 13 }} {...PreviousProps}>
                          {option}
                        </Box>
                      )}
                      fullWidth
                      // className='Margintop'
                      // sx={{ width: '20vw', mt: 2 }}
                      name='Class'
                      size='small'
                      options={ClassArray}
                      // defaultValue='50'
                      value={
                        quickQuoteFlow
                          ? PreviousProps?.commodityInfo?.[0]?.freightClass
                          : PreviousProps?.details?.[0]?.freightClass
                      }
                      onChange={(event, newValue) =>
                        handleClassInputChange('Class', index, newValue)
                      }
                      // sx={{ marginLeft: 1 }}
                      renderInput={params => (
                        <TextField
                          fullWidth
                          label='Freight Class'
                          variant='standard'
                          // sx={{ width: '20vw' }}
                          // placeholder='Payment Type'

                          {...params}
                          InputProps={{
                            disableUnderline: false
                            // ...params.InputProps
                          }}
                        />
                      )}
                    />

                    {props?.location?.state?.rateType !== 'Quick Quote' && (
                      <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                        <TextField
                          // className='RightMarginItems'
                          InputProps={{
                            disableUnderline: false
                          }}
                          fullWidth
                          // sx={{ width: '20vw', mt: 2 }}
                          variant='standard'
                          disabled
                          label='NMFC'
                          name='NMFCnumber'
                          // defaultValue='5242141'
                          value={PreviousProps?.details?.[0]?.nmfc}
                          onChange={event =>
                            handleClassInputChange('NMFCnumber', index, event)
                          }
                          size='small'
                          id='outlined-password-input'
                          // type='number'
                          autoComplete='current-password'
                          // value={'149980-02'}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}
              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    // required
                    inputRef={enterSONumbe}
                    error={Boolean(validationErrors['saleOrderNumberError'])}
                    helperText={validationErrors['saleOrderNumberError']}
                    // className='Margintop'
                    disabled={quickQuoteFlow ? false : true}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    label='Shipment #'
                    value={
                      quickQuoteFlow ? saleOrderNumber : PreviousProps?.soNumber
                    }
                    onChange={e => {
                      setValidationErrors({
                        ...validationErrors,
                        saleOrderNumberError: null
                      });
                      setSaleOrderNumber(e.target.value);
                    }}
                    // type='number'
                    variant='standard'
                    fullWidth
                    // sx={
                    //   quickQuoteFlow
                    //     ? { width: '19vw', mr: 2, mt: 2 }
                    //     : { width: '20vw', mt: 2 }
                    // }
                    // placeholder='Payment Type'
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    // className='RightMarginItems'
                    disabled={quickQuoteFlow ? false : true}
                    InputProps={{
                      disableUnderline: quickQuoteFlow ? false : true
                    }}
                    fullWidth
                    sx={{ mt: 0.4 }}
                    variant='standard'
                    label='Customer PO#'
                    value={
                      quickQuoteFlow
                        ? customerPoNmb
                        : PreviousProps?.clientPONumber
                    }
                    onChange={e => setCustomerPoNmb(e.target.value)}
                    size='small'
                    id='outlined-password-input'
                    // type='number'
                    // autoComplete='current-password'
                    // value={'149980-02'}
                  />
                </Grid>
              </Grid>
              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                {PreviousProps?.proNumber && (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: true
                      }}
                      disabled
                      className='Margintop'
                      value={PreviousProps?.proNumber}
                      onChange={e => setProNumber(e.target.value)}
                      size='small'
                      sx={{ width: '20vw' }}
                      variant='standard'
                      label='PRO#'
                      type='text'
                      inputProps={{ disableUnderline: true }}
                    />
                  </Grid>
                )}
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <TextField
                    InputProps={{
                      disableUnderline: false
                    }}
                    disabled
                    className='RightMarginItems'
                    value={selectedCarrierQuotaionID}
                    onChange={e => setRefOrQuoteNmb(e.target.value)}
                    size='small'
                    fullWidth
                    // sx={{ width: '20vw' }}
                    label='Ref / Quote# If any'
                    type='text'
                    variant='standard'
                    inputProps={{ disableUnderline: false }}
                  />
                </Grid>
                {quickQuoteFlow && (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      InputProps={{
                        disableUnderline: false
                      }}
                      disabled
                      className='RightMarginItems'
                      value={totalNetChargeState}
                      size='small'
                      fullWidth
                      // sx={{ width: '20vw' }}
                      label='Total Net Charge'
                      type='text'
                      variant='standard'
                      inputProps={{ disableUnderline: false }}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid sx={{ mt: 2, display: 'flex' }} gap={2} container>
                {PreviousProps?.proNumber && (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      // className='Margintop'
                      disabled
                      value={PreviousProps?.proNumber}
                      // value='98642469'
                      onChange={e => setBOLNumber(e.target.value)}
                      type='text'
                      size='small'
                      fullWidth
                      // sx={{ width: '20vw', mt: 2 }}
                      label='BOL#'
                      variant='standard'
                      InputProps={{
                        disableUnderline: false
                      }}
                    />
                  </Grid>
                )}
                {PreviousProps?.pickupNumber && (
                  <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                    <TextField
                      // className='RightMarginItems'
                      variant='standard'
                      InputProps={{
                        disableUnderline: false
                      }}
                      disabled
                      value={PreviousProps?.pickupNumber}
                      onChange={e => setPoRefNumber(e.target.value)}
                      type='text'
                      size='small'
                      fullWidth
                      // sx={{ width: '20vw' }}
                      label='Pickup#'
                    />
                  </Grid>
                )}
              </Grid>
              <Grid sx={{ mt: 0, display: 'flex' }} gap={2} container>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <Autocomplete
                    freeSolo
                    disabled
                    // className='Margintop'
                    // sx={{ width: '20vw', margin: '15 0 0 0' }}
                    renderOption={(PreviousProps, option) => (
                      <Box style={{ fontSize: 13 }} {...PreviousProps}>
                        {option}
                      </Box>
                    )}
                    size='small'
                    options={PaymentTypeArr}
                    value={paymentTypeValue()}
                    onChange={(event, newValue) => {
                      setPaymentType(newValue);
                      setValidationErrors({
                        ...validationErrors,
                        paymentTerms: null
                      });
                    }}
                    // sx={{ marginLeft: 1 }}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        disabled
                        variant='standard'
                        FormHelperTextProps={{ style: { margin: '5 30 0 0' } }}
                        error={Boolean(validationErrors['paymentTerms'])}
                        helperText={validationErrors['paymentTerms']}
                        label='Freight Payment Type'
                        {...params}
                        InputProps={{
                          disableUnderline: false,
                          ...params.InputProps
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={11} sm={10} md={3} lg={3} xl={3}>
                  <Autocomplete
                    freeSolo
                    disabled
                    fullWidth
                    // sx={{ width: '20vw' }}
                    renderOption={(PreviousProps, option) => (
                      <Box style={{ fontSize: 13 }} {...PreviousProps}>
                        {option}
                      </Box>
                    )}
                    size='small'
                    // options={HazmatOptions}
                    value={hazmatSwitch ? 'Yes' : 'No'}
                    onChange={(event, newValue) => {
                      setHazmatType(newValue);
                      setValidationErrors({
                        ...validationErrors,
                        paymentTerms: null
                      });
                    }}
                    // sx={{ marginLeft: 1 }}
                    renderInput={params => (
                      <TextField
                        // sx={{ mt: 2 }}
                        // className='RightMarginItems'
                        variant='standard'
                        inputProps={{ disableUnderline: true }}
                        FormHelperTextProps={{ style: { margin: '5 30 0 0' } }}
                        error={Boolean(validationErrors['paymentTerms'])}
                        helperText={validationErrors['paymentTerms']}
                        label='Hazmat'
                        {...params}
                        InputProps={{
                          disableUnderline: false,
                          ...params.InputProps
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
            <br />
            {(insidePickupSwitch ||
              liftgatePickupSwitch ||
              residentialPickupSwitch ||
              secureAccesPickupSwitch ||
              limitedPickupAccessSwitch ||
              freezeProtectionPickupSwitch ||
              insideDeliverySwitch ||
              liftgateDeliverySwitch ||
              residentialDeliverySwitch ||
              secureAccesDeliverySwitch ||
              limitedDeliverySwitch ||
              callBeforeDeliveryServicesSwitch) && (
              <>
                <div className='OriginTitle'>Services Optional</div>
                <hr />
                <Box sx={{ color: 'rgba(0, 0, 0, 0.38)' }}>
                  <div className='PreviewServicesSwitches'>
                    <Typography
                      sx={{ width: '20vw' }}
                      fontSize={13}
                      className='TopPreviewSwitcheLabels'
                    >
                      PickUp Services
                    </Typography>
                    <Typography
                      fontSize={13}
                      className='TopPreviewSwitcheLabels'
                    >
                      Delivery Services
                    </Typography>
                  </div>
                  <div className='PreviewServicesSwitches'>
                    <div style={{ width: '20vw' }}>
                      <FormControl sx={{ m: 0 }} size='large'>
                        {insidePickupSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='TopPreviewSwitcheLabels'>
                              Inside Pickup
                            </Typography>
                          </div>
                        )}
                        {liftgatePickupSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Lift Gate Services
                            </Typography>
                          </div>
                        )}
                        {residentialPickupSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Residential Pickup
                            </Typography>
                          </div>
                        )}
                        {secureAccesPickupSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Secure Access
                            </Typography>
                          </div>
                        )}
                        {limitedPickupAccessSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Limited Access
                            </Typography>
                          </div>
                        )}
                        {freezeProtectionPickupSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Freeze Protection
                            </Typography>
                          </div>
                        )}
                      </FormControl>
                    </div>

                    <div>
                      <FormControl size='large'>
                        {insideDeliverySwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='TopPreviewSwitcheLabels'>
                              Inside Delivery
                            </Typography>
                          </div>
                        )}
                        {liftgateDeliverySwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Lift Gate Services
                            </Typography>
                          </div>
                        )}
                        {residentialDeliverySwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Residential Delivery
                            </Typography>
                          </div>
                        )}

                        {secureAccesDeliverySwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Secure Access
                            </Typography>
                          </div>
                        )}
                        {limitedDeliverySwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Limited Access
                            </Typography>
                          </div>
                        )}

                        {callBeforeDeliveryServicesSwitch && (
                          <div className={classes.switchRoot}>
                            <Typography className='PreviewSwitcheLabels'>
                              Call Before Delivery
                            </Typography>
                          </div>
                        )}
                      </FormControl>
                    </div>
                  </div>
                  <br />
                  {CODAmount && (
                    <div className={classes.switchRoot}>
                      <Typography className='PreviewSwitcheLabels'>
                        COD Amount ($): {CODAmount}
                      </Typography>
                    </div>
                  )}
                  {DeclaredValue && (
                    <div className={classes.switchRoot}>
                      <Typography className='PreviewSwitcheLabels'>
                        Declared Value($): {DeclaredValue}
                      </Typography>
                    </div>
                  )}
                  {overlengthPickupSwitch && (
                    <div className={classes.switchRoot}>
                      <Typography className='PreviewSwitcheLabels'>
                        Overlength: {overLengthValue}
                      </Typography>
                    </div>
                  )}
                </Box>
              </>
            )}
            <br />
            {(pickupRemarks || deliveryRemarks) && (
              <>
                <div className='OriginTitle'>Remarks</div>
                <hr />
                <Box
                  sx={{ color: 'rgba(0, 0, 0, 0.38)' }}
                  className='RemarksParent'
                >
                  {pickupRemarks && (
                    <div>
                      <Typography variant='caption' color='GrayText'>
                        Pickup Instructions:
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{ __html: pickupRemarks }}
                      />
                    </div>
                  )}
                  {deliveryRemarks && (
                    <div>
                      <Typography variant='caption' color='GrayText'>
                        Delivery Instructions:
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{ __html: deliveryRemarks }}
                      />
                    </div>
                  )}
                </Box>
              </>
            )}
          </Box>
        );
      }
    }
  };

  function handleCopy() {
    // Get the text field
    var copyText = document.getElementById('myInput');
    // Select the text field
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
  }
  const handleDoneShipment = DoneStatus => {
    if (DoneStatus === 'booked') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'Booked' }
      });
    }
    if (DoneStatus === 'InTransit') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'InTransit' }
      });
    }
    if (DoneStatus === 'Delivered') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'Delivered' }
      });
    }

    // history.push('/');
    // if (props?.location?.state?.disptachOpen !== 'Get Quote') {
    handleReset();
    setShipmentBooked(false);
    setShipmentDispatchMsg('');
    handleResetAllData();
    // }

    // if (props?.location?.state?.disptachOpen === 'Dispatch') {
    //   setOpenOtherCarrier(false);
    //   handleReset();
    //   handlePickupClose();
    //   setShipmentDispatchMsg('');
    //   handleResetAllData();
    // }
  };

  const handleCancelShipment = () => {
    // handlePickupClose();
    handleReset();
    setShipmentFailed(false);
    history.push('/');
  };

  const handleBackShipment = () => {
    setShipmentFailed(false);
    setShipmentDispatchFailed(false);
    handleReset();
  };
  const handleStep = (step, label) => () => {
    setActiveStep(step);
    setActiveTabLabel(label);
  };
  const stepsArray = () => {
    if (props?.location?.state?.disptachOpen === 'Get Quote') {
      const steps = ['Carrier Rates', 'Pickup Info', 'Preview'];
      return steps;
    } else {
      const steps = ['Shipment Info', 'Preview'];
      return steps;
    }
  };

  const handleNextButton = () => {
    if (stepsArray().length === 2) {
      if (
        props?.location?.state?.disptachOpen === 'Dispatch' &&
        !shipmentDispatchFailed
      ) {
        return 'Dispatch';
      } else if (
        props?.location?.state?.disptachOpen === 'PickUp' &&
        !shipmentDispatchFailed
      ) {
        return 'Confirm PickUp';
      } else {
        return 'Cancel';
      }
    }
    if (
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      !shipmentFailed &&
      stepsArray().length === 3
    ) {
      return 'Confirm Pickup';
    }
    if (
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      shipmentFailed &&
      stepsArray().length === 3
    ) {
      return 'Cancel';
    }
  };

  useEffect(() => {}, []);

  const calculateWidth = () => {
    // You can adjust any additional padding or margin as needed
    const padding = 10;
    const minWidth = 100; // Set a minimum width if needed

    const valueLength = pickupReferenceNumber.length;
    const calculatedWidth = valueLength * 10 + padding;

    // Ensure the width is not below the minimum
    return Math.max(calculatedWidth, minWidth);
  };

  const handlePhoneNumberChange = event => {
    const inputValue = event.target.value;
    // Remove non-numeric characters and retain formatting
    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    setDriverNumber(formattedValue);

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, driverNumber: null });
    } else {
      setPhoneNumberValidError(true);
      errors['driverNumber'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };
  const ShipmentContent = () => {
    if (pickUpLoader) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <CircularProgress />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Box>
      );
    }
    if (shipmentFailed || shipmentDispatchFailed) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <WarningAmberIcon style={{ fontSize: 150, color: '#D32F2F' }} />{' '}
          <br />
          <br />
          <Typography variant='h4'>Error</Typography>
          <br />
          <div>{shipmentFailedMsg}</div>
          <br />
          <br />
        </Box>
      );
    }
    if (shipmentDispatchMsg && !shipmentDispatchFailed) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <CheckCircleIcon style={{ fontSize: 150, color: '#2E7D32' }} />{' '}
          <Typography variant='h4'>
            {shipmentDispatchMsg === 'InTransit'
              ? 'Your shipment has been picked-up and saved in-transit'
              : 'Your shipment has been picked-up and saved in delivered'}
          </Typography>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          {/* <br /> */}
          <Button
            sx={{
              width: '25%',
              height: 40
            }}
            variant='contained'
            onClick={() => handleDoneShipment(shipmentDispatchMsg)}
          >
            Done
          </Button>
        </Box>
      );
    }
    if (shipmentBooked) {
      return (
        <>
          <Box sx={{ textAlign: 'center' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <CheckCircleIcon style={{ fontSize: 150, color: '#2E7D32' }} />{' '}
            <Typography variant='h4'>{pickupSuccessRemarks}</Typography>
            <br />
            <div className='ParentCopyNmbBook'>
              <div className='OuterCopyNmbBook'>
                Reference Number:
                <input
                  style={{ width: `${calculateWidth()}px` }}
                  className='CopyNmbBook'
                  id='myInput'
                  value={pickupReferenceNumber}
                  readOnly
                />
                <ContentCopyIcon
                  onClick={() => handleCopy()}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Button
              sx={{
                width: '25%',
                height: 40
              }}
              variant='contained'
              onClick={() => handleDoneShipment('booked')}
            >
              Done
            </Button>
          </Box>
        </>
      );
    } else {
      return (
        <Box
          sx={
            props?.location?.state?.disptachOpen === 'Get Quote' &&
            activeStep === 0
              ? {
                  height: {
                    xs: '82%',
                    sm: '82%',
                    md: '86vh',
                    lg: '86vh',
                    xl: '86vh'
                  },
                  width: '100%'
                }
              : props?.location?.state?.disptachOpen === 'Dispatch'
              ? { height: '61vh', width: '100%' }
              : { height: '75vh', width: '100%' }
          }
        >
          <Stepper
            // className='PickupStepperParent'
            activeStep={activeStep}
            // alternativeLabel
            // nonLinear
          >
            {stepsArray().map((label, index) => {
              const stepProps = {};

              return (
                <Step key={label} {...stepProps}>
                  <StepButton
                    color='inherit'
                    onClick={handleStep(index, label)}
                  >
                    {label}
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>
          {handleStepperContent(activeStep, activeTabLabel)}
        </Box>
      );
    }
  };

  const isWeekend = date => {
    const [year, month, day] = date.split('-'); // Assuming the date format is 'YYYY-MM-DD'
    const selectedDate = new Date(year, month - 1, day); // Construct date object without time
    const dayOfWeek = selectedDate.getDay();
    return dayOfWeek === 6 || dayOfWeek === 0; // Saturday = 6, Sunday = 0
  };
  const isPastDate = date => {
    const [year, month, day] = date.split('-'); // Assuming the date format is 'YYYY-MM-DD'
    const selectedDate = new Date(Date.UTC(year, month - 1, day)); // Create the date object in UTC

    const today = new Date(); // Get the current date
    const todayUTC = new Date(
      Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
    ); // Normalize to midnight UTC

    return selectedDate < todayUTC; // Compare the dates
  };

  const handleDateChange = e => {
    const newDate = e.target.value;

    const currentDate = new Date();
    const thirtyDaysLater = new Date(currentDate);
    thirtyDaysLater.setDate(currentDate.getDate() + 30);

    if (isPastDate(newDate)) {
      setValidationErrors({
        originDate: 'Past dates are not valid as pickup date'
      });
      return;
    } else if (isWeekend(newDate)) {
      setValidationErrors({
        originDate: 'Weekends are not valid as pickup date'
      });
      return;
    } else if (
      selectedCarrierNameQuoteRates == 'SAIA' &&
      new Date(newDate) > thirtyDaysLater
    ) {
      setValidationErrors({
        originDate: 'Pickup date cannot be more than 30 days in the future'
      });
      return;
    } else {
      setValidationErrors({});
      setOriginDate(newDate); // Update the date if it's not a weekend
    }
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box sx={{ minHeight: '90vh', width: '100%', overflow: 'hidden' }}>
        <ToastContainer
          style={
            // isMobile
            //   ? { width: '100%', display: 'flex', justifyContent: 'center' }
            //   :
            { width: 'auto' }
          }
          position='top-center'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Paper className='Grid_Item_Get_Quote'>
          <Dialog
            className='InnerDialog'
            open={openOtherCarrier}
            onClose={handleOtherCarrierClose}
          >
            <DialogContent>
              <DialogContentText>
                <TextField
                  variant='standard'
                  error={Boolean(validationErrors['otherCarrierName'])}
                  helperText={validationErrors['otherCarrierName']}
                  value={otherCarrierName}
                  onChange={e => {
                    setOtherCarrierName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      otherCarrierName: null
                    });
                  }}
                  sx={{ width: '100%', mt: 5 }}
                  size='small'
                  label='Carrier Name'
                />
                <TextField
                  variant='standard'
                  error={Boolean(validationErrors['truckNumber'])}
                  helperText={validationErrors['truckNumber']}
                  value={truckNumber}
                  onChange={e => {
                    setTruckNumber(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      truckNumber: null
                    });
                  }}
                  sx={{ width: '100%', mt: 5 }}
                  size='small'
                  label='Truck Number'
                />
                <TextField
                  variant='standard'
                  error={Boolean(validationErrors['driverName'])}
                  helperText={validationErrors['driverName']}
                  value={driverName}
                  onChange={e => {
                    setDriverName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      driverName: null
                    });
                  }}
                  sx={{ width: '49%', mt: 5 }}
                  size='small'
                  label='Driver Name'
                />
                <TextField
                  variant='standard'
                  error={Boolean(validationErrors['driverNumber'])}
                  helperText={validationErrors['driverNumber']}
                  value={driverNumber}
                  onChange={handlePhoneNumberChange}
                  sx={{ width: '49%', margin: '40 0 0 8' }}
                  size='small'
                  label='Driver Number'
                  type='text'
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                sx={{ width: '49%' }}
                variant='outlined'
                onClick={handleOtherCarrierClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ width: '49%' }}
                variant='contained'
                onClick={handleSaveOtherCarrier}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <div>
            {ShipmentContent()}
            {!shipmentDispatchMsg && !shipmentBooked && (
              <div
                className={
                  !isSmUp
                    ? props?.location?.state?.disptachOpen === 'Get Quote'
                      ? activeStep === 0
                        ? 'NextBtnRates_BookShipmet'
                        : 'NextBtnRates'
                      : 'NextBtnDiv'
                    : ''
                }
              >
                {activeStep !== 0 && (
                  <Button
                    size={isSmUp ? 'small' : 'medium'}
                    fullWidth={isSmUp ? true : false}
                    disabled={failedShip && activeStep === 1 ? true : false}
                    sx={{
                      mt: { xs: 3, sm: 1, md: 0, lg: 0, xl: 0 },
                      mr: 1
                    }}
                    onClick={
                      shipmentFailed || shipmentDispatchFailed
                        ? handleBackShipment
                        : handleBack
                    }
                    // className='BtnColor'
                    variant='outlined'
                  >
                    <ChevronLeftIcon sx={{ m: 0 }} className='PrevBtnIcon' />{' '}
                    Previous
                  </Button>
                )}
                {console.log(allRatesFetched, 'allRatesFetched')}
                {((userPermissionsArr &&
                  userPermissionsArr.filter(permissions => permissions.level5)
                    .length &&
                  currentScreen.pathname === '/bookshipment') ||
                  (manageShipPermissions &&
                    manageShipPermissions.filter(
                      permissions => permissions.level6
                    ).length &&
                    currentScreen.pathname === '/dispatchshipmentLTL') ||
                  UserIsAdmin) && (
                  <Button
                    size={isSmUp ? 'small' : 'medium'}
                    fullWidth={isSmUp ? true : false}
                    sx={{
                      mt: { xs: 1, sm: 1, md: 0, lg: 0, xl: 0 }
                    }}
                    disabled={
                      props?.location?.state?.origin !== 'Logs' &&
                      props?.location?.state?.disptachOpen === 'Get Quote' &&
                      (selectedIndex === null ||
                        !DisableReloadButton() ||
                        !allRatesFetched)
                    }
                    onClick={
                      shipmentFailed || shipmentDispatchFailed
                        ? () => handleCancelShipment()
                        : () => handleNext(activeStep)
                    }
                    variant='contained'
                    startIcon={activeStep === 0 ? <CheckCircleIcon /> : ''}
                  >
                    {' '}
                    {activeStep === stepsArray().length - 1
                      ? handleNextButton()
                      : shipmentFailed || shipmentDispatchFailed
                      ? 'Cancel'
                      : props?.location?.state?.disptachOpen === 'Get Quote' &&
                        activeStep === 0
                      ? 'Book Shipment'
                      : 'Next'}
                    {!shipmentFailed ||
                      (shipmentDispatchFailed && (
                        <ChevronRightIcon className='NextBtnIcon' />
                      ))}
                  </Button>
                )}
              </div>
            )}
          </div>
        </Paper>
      </Box>
    </Grid>
  );
}
